import { getLegacyStorageKey } from '../../utils/storage';
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useTdsCommon } from '../../hooks/useTdsCommon'
import { getStateCode, formatDate, formatDecimalAmount, padString, padNumber, stateCodes, reverseStateCodes } from '../../utils/tdsCommon'
import { extractProfileDataApi, downloadCsiFileApi } from '../../utils/tdsFileHandlers'
import TdsProfileSection from '../../components/dashboard/TdsProfileSection'
import { getStorageItem, setStorageItem } from '../../utils/storage'

import { motion } from 'framer-motion'
import { FileText, User, Upload, ArrowLeft, Building2, X, Trash2, Eye, EyeOff } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios'

import TdsDetailsTable from '../../components/dashboard/TdsDetailsTable'
import ChallanDetailsTable from '../../components/dashboard/ChallanDetailsTable'
import TdsSidebar from '../../components/dashboard/TdsSidebar'
import TdsGeneratedFiles from './TdsGeneratedFiles';
import { useError } from '../../contexts/ErrorContext'


const stateOptions = [
    'ANDAMAN AND NICOBAR ISLANDS',
    'ANDHRA PRADESH',
    'ARUNACHAL PRADESH',
    'ASSAM',
    'BIHAR',
    'CHANDIGARH',
    'CHHATTISGARH',
    'DADRA & NAGAR HAVELI AND DAMAN & DIU',
    'DELHI',
    'GOA',
    'GUJARAT',
    'HARYANA',
    'HIMACHAL PRADESH',
    'JAMMU & KASHMIR',
    'JHARKHAND',
    'KARNATAKA',
    'KERALA',
    'LADAKH',
    'LAKSHWADEEP',
    'MADHYA PRADESH',
    'MAHARASHTRA',
    'MANIPUR',
    'MEGHALAYA',
    'MIZORAM',
    'NAGALAND',
    'ODISHA',
    'PONDICHERRY',
    'PUNJAB',
    'RAJASTHAN',
    'SIKKIM',
    'TAMIL NADU',
    'TELANGANA',
    'TRIPURA',
    'UTTAR PRADESH',
    'UTTARAKHAND',
    'WEST BENGAL'
];

// SECTION CODES FOR 27Q
const sectionOptions27Q_old = [
    { value: '194E', label: '194E - Payment to Non-Res. Sportsmen/Sports Assn.' }, // 94E
    { value: '195', label: '195 - Other sums payable to Non-Resident' }, // 195
    { value: '196A', label: '196A - Income from units (Non-Resident)' }, // 96A
    { value: '196B', label: '196B - Income from units (Offshore Fund)' }, // 96B
    { value: '196C', label: '196C - Income from foreign currency bonds' }, // 96C
    { value: '196D', label: '196D - Income of FII from securities' }, // 96D - Remittance code 16/27 applicable
    // 194LB, 194LC, 194LD, 192A, 194LBA, 194LBB, 194LBC, 194N
    { value: '194LB', label: '194LB - Income of Infrastructure Debt Fund' }, // 4LB
    { value: '194LC', label: '194LC - Income from Indian Company (Interest)' }, // 4LC
    { value: '194LC(2)(i)', label: '194LC(2)(i) - Income under clause (i)' }, // LC1
    { value: '194LC(2)(ib)', label: '194LC(2)(ib) - Income under clause (ib)' }, // LC2
    { value: '194LC(2)(ic)', label: '194LC(2)(ic) - Income under clause (ic)' }, // LC3
    { value: '194LD', label: '194LD - Interest on certain bonds/Govt. securities' }, // 4LD
    { value: '192A', label: '192A - Payment of accumulated balance to employee (RPF)' }, // 2AA
    { value: '194LBA', label: '194LBA - Income from units of Business Trust' }, // 4BA
    { value: '194LBB', label: '194LBB - Income in respect of units of Investment Fund' }, // LBB
    { value: '194LBC', label: '194LBC - Income in respect of investment in Securitization Trust' }, // LBC
    { value: '194N', label: '194N - Cash Withdrawal > 1 Crore' }, // 94N
    { value: '194LBA(a)', label: '194LBA(a) - Interest from Business Trust (Non-Res)' }, // BA1
    { value: '194LBA(b)', label: '194LBA(b) - Dividend from Business Trust (Non-Res)' }, // BA2
    { value: '194LBA(c)', label: '194LBA(c) - Rent from Business Trust (Non-Res)' }, // BA3
    { value: '194NF', label: '194NF - Cash payment to non-filers' }, // 4NF
    { value: '196D(1A)', label: '196D(1A) - Income of specified fund from securities' }, // 6DA
    { value: '194B', label: '194B - Winnings from lottery/crossword' }, // 94B
    { value: '194B-P', label: '194B-P - Winnings from lottery/crossword (Kind)' }, // 4BP
    { value: '194BA', label: '194BA - Winnings from online games' }, // 9BA
    { value: '194BA-P', label: '194BA-P - Net Winnings from online games (Kind)' }, // 4AP
    { value: '194BB', label: '194BB - Winnings from horse race' }, // 4BB
    { value: '194NC', label: '194NC - Cash payment to Co-op Societies' }, // 4NC
    { value: '194N-FT', label: '194N-FT - Cash payment to Non-filer Co-op Societies' }, // 9FT
    { value: '194T', label: '194T - Payment to partner of firm (Salary/Remuneration)' } // 94T
];

const sectionOptions27Q_new = [
    { value: '1040', label: '1040' },
    { value: '1041', label: '1041' },
    { value: '1042', label: '1042' },
    { value: '1043', label: '1043' },
    { value: '1044', label: '1044' },
    { value: '1045', label: '1045' },
    { value: '1046', label: '1046' },
    { value: '1048', label: '1048' },
    { value: '1049', label: '1049' },
    { value: '1050', label: '1050' },
    { value: '1051', label: '1051' },
    { value: '1052', label: '1052' },
    { value: '1053', label: '1053' },
    { value: '1054', label: '1054' },
    { value: '1055', label: '1055' },
    { value: '1056', label: '1056' },
    { value: '1057', label: '1057' }
];

// NATURE OF REMITTANCE OPTIONS
const remittanceOptions = [
    { value: '16', label: '16 - DIVIDEND' },
    { value: '21', label: '21 - FEES FOR TECHNICAL SERVICES/ FEES FOR INCLUDED SERVICES' },
    { value: '27', label: '27 - INTEREST PAYMENT' },
    { value: '28', label: '28 - INVESTMENT INCOME' },
    { value: '31', label: '31 - LONG TERM CAPITAL GAINS (Others)' },
    { value: '66', label: '66 - Long Term Capital Gain u/s 115E (NRI)' },
    { value: '67', label: '67 - Long Term Capital Gain u/s 112(1)(c)(iii)' },
    { value: '68', label: '68 - Long Term Capital Gain u/s 112' },
    { value: '69', label: '69 - Long Term Capital Gain u/s 112A' },
    { value: '49', label: '49 - ROYALTY' },
    { value: '52', label: '52 - SHORT TERM CAPITAL GAINS' },
    { value: '70', label: '70 - SHORT TERM CAPITAL GAINS U/S 111A' },
    { value: '99', label: '99 - OTHER INCOME / OTHER (NOT IN THE NATURE OF INCOME)' },
    { value: '71', label: '71 - LTCG - Transfer of units u/s 115AB' },
    { value: '72', label: '72 - LTCG - Transfer of bonds/GDR u/s 115AC' }
]

const getFvuSectionCode27Q = (uiCode) => {
    const sectionMapping27Q = {
        '194E': '94E',
        '195': '195',
        '196A': '96A',
        '196B': '96B',
        '196C': '96C',
        '196D': '96D',
        '194LB': '4LB',
        '194LC': '4LC',
        '194LC(2)(i)': 'LC1',
        '194LC(2)(ib)': 'LC2',
        '194LC(2)(ic)': 'LC3',
        '194LD': '4LD',
        '192A': '2AA',
        '194LBA': '4BA',
        '194LBB': 'LBB',
        '194LBC': 'LBC',
        '194N': '94N',
        '194LBA(a)': 'BA1',
        '194LBA(b)': 'BA2',
        '194LBA(c)': 'BA3',
        '194NF': '4NF',
        '196D(1A)': '6DA',
        '194B': '94B',
        '194B-P': '4BP',
        '194BA': '9BA',
        '194BA-P': '4AP',
        '194BB': '4BB',
        '194NC': '4NC',
        '194N-FT': '9FT',
        '194T': '94T'
    };
    return sectionMapping27Q[uiCode] || uiCode;
};




// DEDUCTEE CODES FOR 27Q (Same as 27EQ)
const deducteeCodes27Q = [
    { value: '01', label: '01 - Company, other than domestic company' },
    { value: '02', label: '02 - Individual' },
    { value: '03', label: '03 - Hindu Undivided Family' },
    { value: '04', label: '04 - Association of Persons (AOP)' },
    { value: '05', label: '05 - Association of Persons (AOP) (Companies)' },
    { value: '06', label: '06 - Co-operative Society' },
    { value: '07', label: '07 - Firm' },
    { value: '08', label: '08 - Body of individuals' },
    { value: '09', label: '09 - Artificial juridical person' },
    { value: '10', label: '10 - Others' }
]

const formatMinorHead27Q = (val) => {
    if (!val) return ''
    const s = String(val).trim()
    if (s === '100' || s === '200' || s === '400') return s
    const lower = s.toLowerCase()
    if (lower.includes('advance')) return '100';
    if (lower.includes('payable') || lower.includes('taxpayer')) return '200'
    if (lower.includes('regular') || lower.includes('assessment')) return '400'
    const match = s.match(/(100|200|400)/)
    if (match) return match[0]
    return s
}

// APPLICABLE TDS OPTIONS
const applicableTdsOptions = [
    { value: 'A', label: 'A - TDS rate as per Income Tax Act' },
    { value: 'B', label: 'B - TDS rate as per DTAA' }
]

const yesNoOptions = ['Yes', 'No'];

// COUNTRY CODES (Filtered selection for UI, logic supports map)
const uniqueCountries = [
    { name: 'AFGHANISTAN', code: '01' },
    { name: 'AUSTRALIA', code: '15' },
    { name: 'BANGLADESH', code: '22' },
    { name: 'CANADA', code: '42' },
    { name: 'CHINA', code: '48' },
    { name: 'FRANCE', code: '85' },
    { name: 'GERMANY', code: '91' },
    { name: 'HONG KONG', code: '109' },
    { name: 'INDIA', code: '113' },
    { name: 'INDONESIA', code: '114' },
    { name: 'JAPAN', code: '123' },
    { name: 'MALAYSIA', code: '150' },
    { name: 'MAURITIUS', code: '158' },
    { name: 'NEPAL', code: '174' },
    { name: 'NETHERLANDS', code: '175' },
    { name: 'NEW ZEALAND', code: '178' },
    { name: 'PHILIPPINES', code: '195' },
    { name: 'QATAR', code: '201' },
    { name: 'RUSSIA', code: '204' },
    { name: 'SAUDI ARABIA', code: '216' },
    { name: 'SINGAPORE', code: '221' },
    { name: 'SOUTH AFRICA', code: '226' },
    { name: 'SRI LANKA', code: '230' },
    { name: 'SWITZERLAND', code: '237' },
    { name: 'THAILAND', code: '250' },
    { name: 'UNITED ARAB EMIRATES', code: '264' },
    { name: 'UNITED KINGDOM', code: '265' },
    { name: 'UNITED STATES OF AMERICA', code: '267' },
    { name: 'OTHERS', code: '' } // Placeholder for complete list if needed
]
// Note: In a real app with 200+ countries, load from a JSON or separate file. 
// For this snippet, I am using the most common ones or parsing the user request fully if required. 
// Given the prompt lists ALL of them, I should probably include them all or a mechanism.
// I'll stick to a subset or generic input if list is too huge for this file, but to be safe I'll assume usage of a complete list file or just map a few important ones + dynamic.
// Actually, I can paste the full list if I compress it, but it might be large.
// I will create a separate constant file for countries locally or just embed the full list.
// For now, let's use the provided list in a condensed format.

const countryOptions = [
    { value: '01', label: 'AFGHANISTAN' }, { value: '02', label: 'AKROTIRI' }, { value: '03', label: 'ALBANIA' },
    { value: '04', label: 'ALGERIA' }, { value: '05', label: 'AMERICAN SAMOA' }, { value: '06', label: 'ANDORRA' },
    { value: '07', label: 'ANGOLA' }, { value: '08', label: 'ANGUILLA' }, { value: '09', label: 'ANTARCTICA' },
    { value: '10', label: 'ANTIGUA AND BARBUDA' }, { value: '11', label: 'ARGENTINA' }, { value: '12', label: 'ARMENIA' },
    { value: '13', label: 'ARUBA' }, { value: '14', label: 'ASHMORE AND CARTIER ISLANDS' }, { value: '15', label: 'AUSTRALIA' },
    { value: '16', label: 'AUSTRIA' }, { value: '17', label: 'AZERBAIJAN' }, { value: '18', label: 'BAHRAIN' },
    { value: '19', label: 'BAILIWICK OF GUERNSEY' }, { value: '20', label: 'BAILIWICK OF JERSEY' },
    { value: '21', label: 'BAKER ISLAND' }, { value: '22', label: 'BANGLADESH' }, { value: '23', label: 'BARBADOS' },
    { value: '24', label: 'BELARUS' }, { value: '25', label: 'BELGIUM' }, { value: '26', label: 'BELIZE' },
    { value: '27', label: 'BENIN PORTO' }, { value: '28', label: 'BERMUDA' }, { value: '29', label: 'BHUTAN' },
    { value: '30', label: 'BOLIVIA' }, { value: '31', label: 'BOSNIAAND HERZEGOVINA' }, { value: '32', label: 'BOTSWANA' },
    { value: '33', label: 'BOUVET ISLAND' }, { value: '34', label: 'BRAZIL' }, { value: '35', label: 'BRITISH INDIAN OCEAN TERRITORY' },
    { value: '36', label: 'BRUNEI' }, { value: '37', label: 'BULGARIA' }, { value: '38', label: 'BURKINA FASO' },
    { value: '39', label: 'BURUNDI' }, { value: '40', label: 'CAMBODIA' }, { value: '41', label: 'CAMEROON' },
    { value: '42', label: 'CANADA' }, { value: '43', label: 'CAPE VERDE' }, { value: '44', label: 'CAYMAN ISLANDS' },
    { value: '45', label: 'CENTRAL AFRICAN REPUBLIC' }, { value: '46', label: 'CHAD' }, { value: '47', label: 'CHILE' },
    { value: '48', label: 'CHINA' }, { value: '49', label: 'CHRISTMAS ISLAND' }, { value: '50', label: 'CLIPPERTON ISLAND' },
    { value: '51', label: 'COCOS (KEELING) ISLANDS' }, { value: '52', label: 'COLOMBIA' }, { value: '53', label: 'COMMONWEALTH OF PUERTO RICO' },
    { value: '54', label: 'COMMONWEALTH OF THE NORTHERN MARIANA ISLANDS' }, { value: '55', label: 'COMOROS' },
    { value: '56', label: 'CONGO,DEMOCRATIC REPUBLIC OF THE' }, { value: '57', label: 'CONGO,REPUBLIC OF THE' },
    { value: '58', label: 'COOK ISLANDS' }, { value: '59', label: 'CORAL SEA ISLANDS' }, { value: '60', label: 'CORAL SEA ISLANDS TERRITORY' },
    { value: '61', label: 'COSTA RICA' }, { value: '62', label: 'COTE D\'IVOIRE' }, { value: '63', label: 'CROATIA' },
    { value: '64', label: 'CUBA' }, { value: '65', label: 'CYPRUS' }, { value: '66', label: 'CZECH REPUBLIC' },
    { value: '67', label: 'DENMARK' }, { value: '68', label: 'DEPARTMENTAL COLLECTIVITY OF MAYOTTE' }, { value: '69', label: 'DHEKELIA' },
    { value: '70', label: 'DJIBOUTI' }, { value: '71', label: 'DOMINICA' }, { value: '72', label: 'DOMINICAN REPUBLIC' },
    { value: '73', label: 'EAST TIMOR (TIMORLASTE)' }, { value: '74', label: 'ECUADOR' }, { value: '75', label: 'EGYPT' },
    { value: '76', label: 'ELSALVADOR' }, { value: '77', label: 'EQUATORIAL GUINEA' }, { value: '78', label: 'ERITREA' },
    { value: '79', label: 'ESTONIA' }, { value: '80', label: 'ETHIOPIA' }, { value: '81', label: 'FALKLAND ISLANDS (ISLAS MALVINAS)' },
    { value: '82', label: 'FAROE ISLANDS' }, { value: '83', label: 'FIJI' }, { value: '84', label: 'FINLAND' },
    { value: '85', label: 'FRANCE' }, { value: '86', label: 'FRENCH GUIANA' }, { value: '87', label: 'FRENCH POLYNESIA' },
    { value: '88', label: 'FRENCH SOUTHERN ISLANDS' }, { value: '89', label: 'GABON' }, { value: '90', label: 'GEORGIA' },
    { value: '91', label: 'GERMANY' }, { value: '92', label: 'GEURNSEY' }, { value: '93', label: 'GHANA' },
    { value: '94', label: 'GIBRALTAR' }, { value: '95', label: 'GREECE' }, { value: '96', label: 'GREENLAND' },
    { value: '97', label: 'GRENADA' }, { value: '98', label: 'GUADELOUPE' }, { value: '100', label: 'GUAM' },
    { value: '101', label: 'GUATEMALA' }, { value: '102', label: 'GUERNSEY' }, { value: '103', label: 'GUINEA' },
    { value: '104', label: 'GUINEABISSAU' }, { value: '105', label: 'GUYANA' }, { value: '106', label: 'HAITI' },
    { value: '107', label: 'HEARD ISLAND AND MCDONALD ISLANDS' }, { value: '108', label: 'HONDURAS' }, { value: '109', label: 'HONG KONG' },
    { value: '110', label: 'HOWLAND ISLAND' }, { value: '111', label: 'HUNGARY' }, { value: '112', label: 'ICELAND' },
    { value: '113', label: 'INDIA' }, { value: '114', label: 'INDONESIA' }, { value: '115', label: 'IRAN' },
    { value: '116', label: 'IRAQ' }, { value: '117', label: 'IRELAND' }, { value: '118', label: 'ISLE OF MAN' },
    { value: '119', label: 'ISRAEL' }, { value: '120', label: 'ITALY' }, { value: '121', label: 'JAMAICA' },
    { value: '122', label: 'JAN MAYEN' }, { value: '123', label: 'JAPAN' }, { value: '124', label: 'JARVIS ISLAND' },
    { value: '125', label: 'JERSEY' }, { value: '126', label: 'JOHNSTON ATOLL' }, { value: '127', label: 'JORDAN' },
    { value: '128', label: 'KAZAKHSTAN' }, { value: '129', label: 'KENYA' }, { value: '130', label: 'KINGMAN REEF' },
    { value: '131', label: 'KIRIBATI' }, { value: '132', label: 'KOREA, NORTH' }, { value: '133', label: 'KOREA, SOUTH' },
    { value: '134', label: 'KOSOVO' }, { value: '135', label: 'KUWAIT' }, { value: '136', label: 'KYRGYZSTAN' },
    { value: '137', label: 'LAOS' }, { value: '138', label: 'LATVIA' }, { value: '139', label: 'LEBANON' },
    { value: '140', label: 'LESOTHO' }, { value: '141', label: 'LIBERIA' }, { value: '142', label: 'LIBYA' },
    { value: '143', label: 'LIECHTENSTEIN' }, { value: '144', label: 'LITHUANIA' }, { value: '145', label: 'LUXEMBOURG' },
    { value: '146', label: 'MACAU' }, { value: '147', label: 'MACEDONIA' }, { value: '148', label: 'MADAGASCAR' },
    { value: '149', label: 'MALAWI' }, { value: '150', label: 'MALAYSIA' }, { value: '151', label: 'MALAYSIA (LABUAN)' },
    { value: '152', label: 'MALDIVES' }, { value: '153', label: 'MALI' }, { value: '154', label: 'MALTA' },
    { value: '155', label: 'MARSHALLISLANDS' }, { value: '156', label: 'MARTINIQUE' }, { value: '157', label: 'MAURITANIA' },
    { value: '158', label: 'MAURITIUS' }, { value: '159', label: 'MAYOTTE' }, { value: '160', label: 'UNITED MEXICAN STATES' },
    { value: '161', label: 'MICRONESIA, FEDERATED STATES OF' }, { value: '162', label: 'MIDWAY ISLANDS' },
    { value: '163', label: 'MOLDOVA' }, { value: '164', label: 'MONACO' }, { value: '165', label: 'MONGOLIA' },
    { value: '166', label: 'MONTENEGRO' }, { value: '167', label: 'MONTSERRAT' }, { value: '168', label: 'MOROCCO' },
    { value: '169', label: 'MOZAMBIQUE' }, { value: '170', label: 'MYANMAR (BURMA)' }, { value: '171', label: 'NAMIBIA' },
    { value: '172', label: 'NAURU' }, { value: '173', label: 'NAVASSA ISLAND' }, { value: '174', label: 'NEPAL' },
    { value: '175', label: 'NETHERLANDS' }, { value: '176', label: 'NETHERLANDS ANTILLES' }, { value: '177', label: 'NEW CALEDONIA' },
    { value: '178', label: 'NEWZEALAND' }, { value: '179', label: 'NICARAGUA' }, { value: '180', label: 'NIGER' },
    { value: '181', label: 'NIGERIA' }, { value: '182', label: 'NIUE' }, { value: '183', label: 'NORFOLK ISLAND' },
    { value: '184', label: 'NORTHERN MARIANA ISLANDS' }, { value: '185', label: 'NORWAY' }, { value: '186', label: 'OMAN' },
    { value: '187', label: 'PAKISTAN' }, { value: '188', label: 'PALAU' }, { value: '189', label: 'PALMYRA ATOLL' },
    { value: '190', label: 'PANAMA' }, { value: '191', label: 'PAPUA NEW GUINEA' }, { value: '192', label: 'PARACEL ISLANDS' },
    { value: '193', label: 'PARAGUAY' }, { value: '194', label: 'PERU' }, { value: '195', label: 'PHILIPPINES' },
    { value: '196', label: 'PITCAIRN ISLANDS' }, { value: '197', label: 'PITCAIRN, HENDERSON, DUCIE, AND OENO ISLANDS' },
    { value: '198', label: 'POLAND' }, { value: '199', label: 'PORTUGAL' }, { value: '200', label: 'PUERTO RICO' },
    { value: '201', label: 'QATAR' }, { value: '202', label: 'REUNION' }, { value: '203', label: 'ROMANIA' },
    { value: '204', label: 'RUSSIA' }, { value: '205', label: 'RWANDA' }, { value: '206', label: 'SAINT BARTHELEMY' },
    { value: '207', label: 'SAINT HELENA' }, { value: '208', label: 'SAINT KITTS AND NEVIS' }, { value: '209', label: 'SAINT LUCIA' },
    { value: '210', label: 'SAINT MARTIN' }, { value: '211', label: 'SAINT PIERRE AND MIQUELON' },
    { value: '212', label: 'SAINT VINCENT AND THE GRENADINES' }, { value: '213', label: 'SAMOA' }, { value: '214', label: 'SANMARINO' },
    { value: '215', label: 'SAO TOME AND PRINCIPE' }, { value: '216', label: 'SAUDI ARABIA' }, { value: '217', label: 'SENEGAL' },
    { value: '218', label: 'SERBIA' }, { value: '219', label: 'SEYCHELLES' }, { value: '220', label: 'SIERRA LEONE' },
    { value: '221', label: 'SINGAPORE' }, { value: '222', label: 'SLOVAKIA' }, { value: '223', label: 'SLOVENIA' },
    { value: '224', label: 'SOLOMON ISLANDS' }, { value: '225', label: 'SOMALIA' }, { value: '226', label: 'SOUTH AFRICA' },
    { value: '227', label: 'SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS' }, { value: '228', label: 'SPRATLY ISLANDS' },
    { value: '229', label: 'SPAIN' }, { value: '230', label: 'SRI LANKA' }, { value: '231', label: 'ST. VINCENT & GRENADINES' },
    { value: '232', label: 'SUDAN' }, { value: '233', label: 'SURINAME' }, { value: '234', label: 'SVALBARD' },
    { value: '235', label: 'SWAZILAND' }, { value: '236', label: 'SWEDEN' }, { value: '237', label: 'SWITZERLAND' },
    { value: '238', label: 'SYRIA' }, { value: '239', label: 'TAIWAN' }, { value: '240', label: 'TAJIKISTAN' },
    { value: '241', label: 'TANZANIA' }, { value: '242', label: 'TERRITORIAL COLLECTIVITY OF ST. PIERRE & MIQUELON' },
    { value: '243', label: 'TERRITORY OF AMERICAN SAMOA' }, { value: '244', label: 'TERRITORY OF ASHMORE AND CARTIER ISLANDS' },
    { value: '245', label: 'TERRITORY OF CHRISTMAS ISLAND' }, { value: '246', label: 'TERRITORY OF COCOS (KEELING) ISLANDS' },
    { value: '247', label: 'TERRITORY OF GUAM' }, { value: '248', label: 'TERRITORY OF HEARD ISLAND & MCDONALD ISLANDS' },
    { value: '249', label: 'TERRITORY OF NORFOLK ISLAND' }, { value: '250', label: 'THAILAND' }, { value: '251', label: 'THE BAHAMAS' },
    { value: '252', label: 'THE GAMBIA' }, { value: '253', label: 'TOGO' }, { value: '254', label: 'TOKELAU' },
    { value: '255', label: 'TONGA' }, { value: '256', label: 'TRINIDAD AND TOBAGO' }, { value: '257', label: 'TUNISIA' },
    { value: '258', label: 'TURKEY' }, { value: '259', label: 'TURKMENISTAN' }, { value: '260', label: 'TURKS AND CAICOS ISLANDS' },
    { value: '261', label: 'TUVALU' }, { value: '262', label: 'UGANDA' }, { value: '263', label: 'UKRAINE' },
    { value: '264', label: 'UNITED ARAB EMIRATES' }, { value: '265', label: 'UNITED KINGDOM' }, { value: '266', label: 'UNITED STATES VIRGIN ISLANDS' },
    { value: '267', label: 'UNITED STATES OF AMERICA' }, { value: '268', label: 'URUGUAY' }, { value: '269', label: 'UZBEKISTAN' },
    { value: '270', label: 'VANUATU' }, { value: '271', label: 'VATICAN CITY (HOLYSEE)' }, { value: '272', label: 'VENEZUELA' },
    { value: '273', label: 'VIETNAM' }, { value: '274', label: 'VIRGIN ISLANDS, BRITISH' }, { value: '275', label: 'VIRGIN ISLANDS, U.S.' },
    { value: '276', label: 'WAKE ISLAND' }, { value: '277', label: 'WALLIS AND FUTUNA' }, { value: '278', label: 'WESTERN SAHARA' },
    { value: '279', label: 'YEMEN' }, { value: '280', label: 'ZAMBIA' }, { value: '281', label: 'ZIMBABWE' },
    { value: '282', label: 'COMBODIA' }, { value: '283', label: 'CONGO' }, { value: '284', label: 'IVORY COAST' },
    { value: '285', label: 'WEST INDIES' }, { value: '286', label: 'BRITISH VIRGIN ISLANDS' }
];

const Tds27QCorrectionForm = ({ isMobile, onSidebarStateChange  }) => {
    const csiFileInputRef = useRef(null);
    console.log('Rendering Tds27QCorrectionForm component');
    const navigate = useNavigate()
    const { addError } = useError()
    const [activeSection, setActiveSection] = useState('profile')
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [sidebarState, setSidebarState] = useState({
        isOpen: false,
        isExpanded: false,
        keepOpen: false,
        hovered: false
    })

    const {
        profileData,
        challanData,
        tdsData,
        originalTdsData,
        csiFile,
        consoFileContent,
        isValidating,
        showCsiUploadPopup,
        showDownloadPrompt,
        selectedFinancialYear,
        selectedQuarter,
        selectedForm,
        selectedReturnType,
        challanDateRange,
        setProfileData,
        setChallanData,
        setTdsData,
        setOriginalTdsData,
        setCsiFile,
        setConsoFileContent,
        setIsValidating,
        setShowCsiUploadPopup,
        setShowDownloadPrompt,
        setSelectedFinancialYear,
        setSelectedQuarter,
        setSelectedForm,
        setSelectedReturnType,
        handlePrepareReturnFile,
        handleValidateReturn,
        handleSkipDownload,
        handleCancelValidation,
        executeValidation
    } = useTdsCommon({
        formName: 'tds27Q',
        defaultFormType: '27Q',
        isCorrection: true,
        generateTdsStatementFile,
        validateDataForReturn,
        onValidationError: (errors) => {
            addError('Please fix the following errors before preparing return:')
            errors.forEach(err => addError(`• ${err}`))
            setSidebarOpen(true)
            setActiveSection('errors')
        }
    });

    const [isProfileEditing, setIsProfileEditing] = useState(true)
    const [downloadPassword, setDownloadPassword] = useState('')
    const [showDownloadPassword, setShowDownloadPassword] = useState(false)
    const [isDownloadingCsi, setIsDownloadingCsi] = useState(false)

    // Profile Pre-fill Automation State
    const [showPrefillPrompt, setShowPrefillPrompt] = useState(false);
    const [prefillPassword, setPrefillPassword] = useState('');
    const [showPrefillPassword, setShowPrefillPassword] = useState(false);
    const [isExtractingProfile, setIsExtractingProfile] = useState(false);

    const [originalProfileData, setOriginalProfileData] = useState(null)
    const [originalChallanData, setOriginalChallanData] = useState([])
    const [batchNumber, setBatchNumber] = useState('1')
    const [consoFhHash, setConsoFhHash] = useState('')

    useEffect(() => {
        (async () => {
            const savedOriginalChallanData = await getStorageItem('tds27QOriginalChallanData')
            const savedOriginalProfileData = await getStorageItem('tds27QOriginalProfileData')
            const savedBatchNumber = localStorage.getItem('tds27QBatchNumber')
            if (savedOriginalChallanData) setOriginalChallanData(savedOriginalChallanData)
            if (savedOriginalProfileData) setOriginalProfileData(savedOriginalProfileData)
            if (savedBatchNumber) setBatchNumber(savedBatchNumber)
        })()
    }, [])

    const handleChallanDataChange = setChallanData;
    const handleTdsDataChange = setTdsData;


    const handleSectionChange = (section) => {
        setActiveSection(section)
    }

    const handleSidebarClose = () => {
        setSidebarOpen(false)
    }

    const handleSidebarStateChange = useCallback((state) => {
        setSidebarState(state)
    }, [])

    // Sync Section 3 address fields with Section 2 when "Same as above" is checked
    useEffect(() => {
        if (
            profileData?.section3?.sameAsAbove &&
            isProfileEditing &&
            profileData?.section2 &&
            profileData?.section3
        ) {
            const newData = { ...profileData }
            if (!newData.section2) newData.section2 = {}
            if (!newData.section3) newData.section3 = {}

            newData.section3.nameOfPremises = newData.section2.nameOfPremises || ''
            newData.section3.flatNo = newData.section2.flatNo || ''
            newData.section3.areaLocality = newData.section2.areaLocality || ''
            newData.section3.roadStreet = newData.section2.roadStreet || ''
            newData.section3.townCity = newData.section2.townCity || ''
            newData.section3.pinCode = newData.section2.pinCode || ''
            newData.section3.state = newData.section2.state || ''
            newData.section3.email = newData.section2.email || ''
      newData.section3.stdCode = newData.section2.stdCode || ''
      newData.section3.telephone = newData.section2.telephoneNo || ''
            setProfileData(newData)
            // Cloud sync via updateProfileData)
        }
    }, [
        profileData?.section2?.nameOfPremises,
        profileData?.section2?.flatNo,
        profileData?.section2?.areaLocality,
        profileData?.section2?.roadStreet,
        profileData?.section2?.townCity,
        profileData?.section2?.pinCode,
        profileData?.section2?.state,
        profileData?.section2?.email,
    profileData?.section2?.stdCode,
    profileData?.section2?.telephoneNo,
        profileData?.section3?.sameAsAbove,
        isProfileEditing
    ])

    // Profile form handlers
    const handleProfileInputChange = (field, value) => {
        const keys = field.split('.')
        const newData = { ...profileData }

        if (!newData.section1) newData.section1 = {}
        if (!newData.section2) newData.section2 = {}
        if (!newData.section3) newData.section3 = {}

        let current = newData
        for (let i = 0; i < keys.length - 1; i++) {
            if (!current[keys[i]]) {
                current[keys[i]] = {}
            }
            current = current[keys[i]]
        }
        current[keys[keys.length - 1]] = value

        if (field === 'section3.sameAsAbove' && value === true && newData.section2 && newData.section3) {
            newData.section3.nameOfPremises = newData.section2.nameOfPremises || ''
            newData.section3.flatNo = newData.section2.flatNo || ''
            newData.section3.areaLocality = newData.section2.areaLocality || ''
            newData.section3.roadStreet = newData.section2.roadStreet || ''
            newData.section3.townCity = newData.section2.townCity || ''
            newData.section3.pinCode = newData.section2.pinCode || ''
            newData.section3.state = newData.section2.state || ''
            newData.section3.email = newData.section2.email || ''
      newData.section3.stdCode = newData.section2.stdCode || ''
      newData.section3.telephone = newData.section2.telephoneNo || ''
        }
        setProfileData(newData)
        // Cloud sync via updateProfileData)
    }

    // Validation function for Prepare Return
    function validateDataForReturn() {
        const errors = []
        if (!tdsData || tdsData.length === 0) errors.push('At least one TDS entry is required')
        if (!challanData || challanData.length === 0) errors.push('At least one Challan entry is required')
        if (!profileData?.section1?.taxDeduction) errors.push('TAN of Deductor is required in Profile')
        if (!profileData?.section1?.permanentAccountNumber) errors.push('PAN of Deductor is required in Profile')
        if (!profileData?.section2?.name) errors.push('Name of Deductor is required in Profile')
        if (!profileData?.section2?.state) errors.push('State is required in Profile Section 2')
        if (!profileData?.section3?.name) errors.push('Responsible Person Name is required in Profile')
        if (!profileData?.section1?.typeOfDeduction) errors.push('Deductor Type is required in Profile')
        if (!profileData?.section3?.designation) errors.push('Responsible Person Designation is required in Profile')
        if (!profileData?.section3?.flatNo && !profileData?.section3?.nameOfPremises && !profileData?.section3?.roadStreet) {
            errors.push('Responsible Person Address is required in Profile')
        }
        if (!profileData?.section3?.state) errors.push('Responsible Person State is required in Profile')
        if (!profileData?.section3?.pinCode) errors.push('Responsible Person Pincode is required in Profile')
        if (!profileData?.section3?.email) errors.push('Responsible Person Email is required in Profile')
        if (!profileData?.section3?.mobileNo) errors.push('Responsible Person Mobile is required in Profile')
        if (!profileData?.section3?.permanentAccountNumber) errors.push('Responsible Person PAN is required in Profile')

        if (tdsData && tdsData.length > 0) {
            tdsData.forEach((row, index) => {
                if (!row.panOfDeductee) errors.push(`TDS Entry ${index + 1}: PAN of Deductee is required`)
                if (!row.sectionCode) errors.push(`TDS Entry ${index + 1}: Section Code is required`)
                if (row.tdsAmount === '' || row.tdsAmount === null || row.tdsAmount === undefined) row.tdsAmount = 0;
                if (!row.dateOfPayment) errors.push(`TDS Entry ${index + 1}: Date of Payment/Credit is required`)
                if (!row.dateOfDeduction && (parseFloat(row.tdsAmount || 0) + parseFloat(row.surcharge || 0) + parseFloat(row.cess || 0)) > 0) errors.push(`TDS Entry ${index + 1}: Date of Deduction is required`)
                if (!row.natureOfRemittance) errors.push(`TDS Entry ${index + 1}: Nature of Remittance is required`)
                if (!row.country) errors.push(`TDS Entry ${index + 1}: Country of Residence is required`)
                if (!row.applicableTds) errors.push(`TDS Entry ${index + 1}: Applicable TDS (IT Act/DTAA) is required`)
                if (parseFloat(row.tdsAmount) > 0 && !row.challanId) errors.push(`TDS Entry ${index + 1}: Challan Selection is required`)
            })
        }

        if (challanData && challanData.length > 0) {
            challanData.forEach((row, index) => {
                if (!row.tdsAmount || parseFloat(row.tdsAmount) <= 0) errors.push(`Challan Entry ${index + 1}: TDS Amount is required`)
                if (!row.dateOfDeposit) errors.push(`Challan Entry ${index + 1}: Date of Deposit is required`)
                if (!row.bsrCode) errors.push(`Challan Entry ${index + 1}: BSR Code is required`)
                else if (row.bsrCode.length !== 7) errors.push(`Challan Entry ${index + 1}: BSR Code must be 7 digits`)
                if (!row.challanSerialNo) errors.push(`Challan Entry ${index + 1}: Challan Serial No. is required`)
                else if (row.challanSerialNo.length !== 5) errors.push(`Challan Entry ${index + 1}: Challan Serial No. must be 5 digits`)
                if (!row.minorHead) errors.push(`Challan Entry ${index + 1}: Minor Head of Challan is required`)

                // Advance Tax (100) check for 4BP and 4AP
                const mappedChallanSection = getFvuSectionCode27Q(row.sectionCode)
                if ((mappedChallanSection === '4BP' || mappedChallanSection === '4AP') && row.minorHead !== '100') {
                    errors.push(`Challan Entry ${index + 1}: Minor Head must be '100' (Advance Tax) for sections 194B-P or 194BA-P`)
                }
            })
        }
        return errors
    }

    function generateTdsStatementFile() {
        const fileCreationDate = new Date().toLocaleDateString('en-GB').replace(/\//g, '')
        let financialYear = ''
        let fyStartYear = 0
        if (selectedFinancialYear) {
            const parts = selectedFinancialYear.split('-')
            if (parts.length >= 2) {
                fyStartYear = parseInt(parts[0])
                const yearPart2 = parts[1].length === 4 ? parts[1].slice(-2) : parts[1]
                financialYear = `${parts[0]}${yearPart2}`
            }
        }
        if (!fyStartYear || isNaN(fyStartYear)) {
            const today = new Date()
            fyStartYear = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1
            financialYear = `${fyStartYear}${String(fyStartYear + 1).slice(-2)}`
        }
        const ayStart = fyStartYear + 1
        const assessmentYear = `${ayStart}${String(ayStart + 1).slice(-2)}`

        let fileContent = ''
        let lineNumber = 1
        const s1 = profileData?.section1 || {}
        const s2 = profileData?.section2 || {}
        const s3 = profileData?.section3 || {}

        const isPanOnlyChange = (tds) => {
            const original = originalTdsData.find(o => o.id === tds.id)
            if (!original) return false
            if (tds.consoMode === 'F') return false
            const panChanged = (tds.panOfDeductee || '') !== (original.panOfDeductee || '')
            if (!panChanged) return false
            const amountSame = parseFloat(tds.tdsAmount || 0) === parseFloat(original.tdsAmount || 0)
            const sectionSame = (tds.sectionCode || '') === (original.sectionCode || '')
            const dateSame = (tds.dateOfPayment || '') === (original.dateOfPayment || '')
            const amtSame = parseFloat(tds.amountOfPayment || 0) === parseFloat(original.amountOfPayment || 0)
            return amountSame && sectionSame && dateSame && amtSame
        }

        const isBhChanged = () => {
            if (!originalProfileData) return false;
            const s1Keys = ['typeOfDeduction'];
            const s2Keys = ['name', 'branchDivision', 'flatNo', 'nameOfPremises', 'roadStreet', 'areaLocality', 'townCity', 'pinCode', 'state', 'email', 'stdCode', 'telephoneNo'];
            const s3Keys = ['name', 'designation', 'flatNo', 'nameOfPremises', 'roadStreet', 'areaLocality', 'townCity', 'pinCode', 'state', 'email', 'mobileNo', 'telephone', 'permanentAccountNumber'];

            const changed1 = s1Keys.some(k => (profileData.section1?.[k] || '') !== (originalProfileData.section1?.[k] || ''));
            const changed2 = s2Keys.some(k => (profileData.section2?.[k] || '') !== (originalProfileData.section2?.[k] || ''));
            const changed3 = s3Keys.some(k => {
                // Special check for PAN since both sections have it
                if (k === 'permanentAccountNumber') {
                    return (profileData.section3?.[k] || '') !== (originalProfileData.section3?.[k] || '');
                }
                return (profileData.section3?.[k] || '') !== (originalProfileData.section3?.[k] || '');
            });

            return changed1 || changed2 || changed3;
        }

        const isCdChanged = () => {
            if (!originalChallanData) return challanData.length > 0;
            if (challanData.length !== originalChallanData.length) return true;
            return challanData.some((c, idx) => {
                const o = originalChallanData[idx];
                if (!o) return true;
                return c.challanSerialNo !== o.challanSerialNo ||
                    c.bsrCode !== o.bsrCode ||
                    c.dateOfDeposit !== o.dateOfDeposit ||
                    parseFloat(c.tdsAmount || 0) !== parseFloat(o.tdsAmount || 0) ||
                    parseFloat(c.totalAmount || 0) !== parseFloat(o.totalAmount || 0);
            });
        }

        const isDdChanged = () => {
            if (!originalTdsData) return tdsData.length > 0;
            if (tdsData.length !== originalTdsData.length) return true;
            return tdsData.some((t, idx) => {
                const o = originalTdsData[idx];
                if (!o) return true;
                // Exclude PAN check here as it's covered by isPanUpdated for C5
                return t.amountOfPayment !== o.amountOfPayment ||
                    t.dateOfPayment !== o.dateOfPayment ||
                    t.dateOfDeduction !== o.dateOfDeduction ||
                    t.sectionCode !== o.sectionCode ||
                    parseFloat(t.tdsAmount || 0) !== parseFloat(o.tdsAmount || 0);
            });
        }

        const isPanUpdated = () => {
            return tdsData.some(t => t.panOfDeductee && t.originalPan && t.panOfDeductee !== t.originalPan);
        }

              

        // ─────────────────────────────────────────────────────────────────────────
        // STEP 2: Classify challans — separate panOnly vs other DD buckets
        // ─────────────────────────────────────────────────────────────────────────
        const challanGroups = challanData.map(challan => {
            const allDDs = tdsData.filter(t => t.challanId == challan.id)
            const changedDDs = allDDs.filter(tds => {
                const original = originalTdsData.find(o => o.id === tds.id)
                return !original || JSON.stringify(tds) !== JSON.stringify(original)
            })
            const originalChallan = originalChallanData.find(c => c.id === challan.id)
            const challanChanged = !originalChallan ||
                challan.challanSerialNo !== originalChallan.challanSerialNo ||
                challan.bsrCode !== originalChallan.bsrCode ||
                challan.dateOfDeposit !== originalChallan.dateOfDeposit ||
                parseFloat(challan.tdsAmount || 0) !== parseFloat(originalChallan.tdsAmount || 0)
            return {
                challan,
                panOnlyDDs: changedDDs.filter(isPanOnlyChange),
                otherDDs: changedDDs.filter(t => !isPanOnlyChange(t)),
                challanChanged
            }
        })

        // ─────────────────────────────────────────────────────────────────────────
        // STEP 3: Determine batches needed (C5 → C2 → C3, optionally C4 for 24Q4)
        // ─────────────────────────────────────────────────────────────────────────
        const c5Groups = challanGroups.filter(g => g.panOnlyDDs.length > 0)
        const c3Groups = challanGroups.filter(g => g.otherDDs.length > 0)
        const c2Groups = challanGroups.filter(g => g.challanChanged && g.panOnlyDDs.length === 0 && g.otherDDs.length === 0)

        const batches = []
        if (c5Groups.length > 0) batches.push({ type: 'C5', groups: c5Groups })
        if (c2Groups.length > 0) batches.push({ type: 'C2', groups: c2Groups })
        if (c3Groups.length > 0) batches.push({ type: 'C3', groups: c3Groups })
        if (batches.length === 0 && isBhChanged()) batches.push({ type: 'C1', groups: [] })
        if (batches.length === 0) {
            const changed = challanGroups.filter(g => g.otherDDs.length > 0 || g.challanChanged)
            batches.push({ type: 'C3', groups: changed })
        }
        const totalBatches = batches.length

        // ─────────────────────────────────────────────────────────────────────────
        // 1. File Header Record (FH)
        // ─────────────────────────────────────────────────────────────────────────
        // 1. File Header (FH) Record
        const fh = []
        fh[1] = lineNumber                   // 1. Line Number (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[2] = 'FH'                         // 2. Record Type (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[3] = 'NS1'                        // 3. File Type (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[4] = 'C';                         // 4. Upload Type (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[5] = fileCreationDate             // 5. File Creation Date (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[6] = '1'                          // 6. File Sequence No. (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[7] = 'D'                          // 7. Uploader Type (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[8] = s1.taxDeduction || ''        // 8. TAN (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[9] = String(totalBatches)         // 9. Total No. of Batches (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[10] = 'Tax Eases Client'          // 10. Name of Return Preparation Utility (Ref: Form_27Q_Correction_FH_Fields.md)
        fh[11] = ''                          // 11. Record Hash (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
        fh[12] = ''                          // 12. FVU Version (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
        fh[13] = ''                          // 13. File Hash (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
        fh[14] = ''                          // 14. Sam Version (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
        fh[15] = ''                          // 15. SAM Hash (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
        fh[16] = ''                          // 16. SCM Version (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
        fh[17] = ''                          // 17. SCM Hash (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
        fh[18] = consoFhHash || ''           // 18. Consolidated File Hash (Ref: Form_27Q_Correction_FH_Fields.md)
        fileContent += fh.slice(1, 19).join('^') + '\n'; lineNumber++;

        // ─────────────────────────────────────────────────────────────────────────
        // Helper: build a BH record
        // ─────────────────────────────────────────────────────────────────────────
        const buildBH = (batchNo, corrType, includesBhChanges, batchTotalAmt) => {
            const dAddr1 = `${s2.flatNo || ''} ${s2.nameOfPremises || ''} ${s2.roadStreet || ''}`.trim()
            const rAddr1 = `${s3.flatNo || ''} ${s3.nameOfPremises || ''} ${s3.roadStreet || ''}`.trim()
            const bh = Array(73).fill('')
            const updInd = includesBhChanges ? '1' : '0'
            bh[1] = lineNumber                       // 1. Line Number (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[2] = 'BH'                             // 2. Record Type (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[3] = String(batchNo)                  // 3. Batch Number (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[4] = ''                               // 4. Record Count (Placeholder, set in calling loop)
            const isNewFormat = fyStartYear >= 2026;
            bh[5] = isNewFormat ? '144' : '27Q'                            // 5. Form Number (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[6] = corrType                         // 6. Transaction Type (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[7] = updInd                           // 7. Batch Updation Indicator (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[8] = s1.receiptNoOriginal || ''       // 8. Token Number of original statement (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[9] = s1.receiptNoEarlier || ''        // 9. Previous statement Token Number (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[10] = ''                              // 10. Token Number (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[11] = ''                              // 11. Date of Token Number (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[12] = s1.taxDeduction || ''           // 12. Last TAN of Deductor (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[13] = s1.taxDeduction || ''           // 13. TAN of Deductor (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[14] = ''                              // 14. Receipt number (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[15] = s1.permanentAccountNumber || '' // 15. PAN of Deductor (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[16] = assessmentYear                  // 16. Assessment Year (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[17] = financialYear                   // 17. Financial Year (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[18] = selectedQuarter                 // 18. Period (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[19] = padString(s2.name, 75)          // 19. Name of Deductor (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[20] = padString(s2.branchDivision, 75) // 20. Branch/Division (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[21] = padString(dAddr1, 25)           // 21. Address 1 (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[22] = padString(s2.areaLocality, 25)  // 22. Address 2 (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[23] = padString(s2.townCity, 25)      // 23. Address 3 (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[24] = ''                              // 24. Address 4 (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[25] = ''                              // 25. Address 5 (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[26] = getStateCode(s2.state)          // 26. State Code (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[27] = s2.pinCode || ''                // 27. PIN Code (Ref: Form_27Q_Correction_BH_Fields.md)
            const deductorStdCode = s2.stdCode || '91'
            const respPersonStdCode = (s3.sameAsAbove ? s2.stdCode : s3.stdCode) || s2.stdCode || '91'
            const respPersonTelephone = (s3.sameAsAbove ? s2.telephoneNo : (s3.telephone || s3.telephoneNo)) || ''

            bh[28] = padString(s2.email, 75)         // 28. Email ID (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[29] = deductorStdCode                 // 29. STD Code (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[30] = s2.telephoneNo || ''            // 30. Telephone No. (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[31] = 'N'                             // 31. Change of Address Deductor (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[32] = s1.typeOfDeduction || ''        // 32. Deductor Type (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[33] = padString(s3.name, 75)          // 33. Name of Resp Person (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[34] = padString(s3.designation, 20)   // 34. Designation (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[35] = padString(rAddr1, 25)           // 35. Resp Person Address 1 (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[36] = padString(s3.areaLocality, 25)  // 36. Resp Person Address 2 (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[37] = padString(s3.townCity, 25)      // 37. Resp Person Address 3 (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[38] = ''                              // 38. Resp Person Address 4 (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[39] = ''                              // 39. Resp Person Address 5 (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[40] = getStateCode(s3.state)          // 40. Resp Person State Code (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[41] = s3.pinCode || ''                // 41. Resp Person PIN Code (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[42] = padString(s3.email, 75)         // 42. Resp Person Email ID (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[43] = s3.mobileNo || ''               // 43. Mobile Number (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[44] = respPersonStdCode               // 44. Resp Person STD Code (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[45] = respPersonTelephone             // 45. Resp Person Telephone (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[46] = s3.hasAddressChanged === 'Yes' ? 'Y' : 'N' // 46. Change of Address Resp Person (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[47] = formatDecimalAmount(batchTotalAmt) // 47. Batch Total Deposit Amount (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[48] = ''                              // 48. Unmatched challan count (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[49] = ''                              // 49. Count of Salary Detail Records (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[50] = ''                              // 50. Batch Total Gross Income (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[51] = 'N'                             // 51. AO Approval (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[52] = ''                              // 52. Earlier period filed (Must be empty for correction)
            bh[53] = originalProfileData?.section1?.typeOfDeduction || s1.typeOfDeduction || '' // 53. Last Deductor Type (Ref: Form_27Q_Correction_BH_Fields.md)
            for (let i = 54; i <= 68; i++) bh[i] = '' // 54-68 (Miscellaneous, No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[59] = s3.permanentAccountNumber || '' // 59. PAN of Responsible Person (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[69] = s2.gstin || ''                  // 69. GSTIN of Deductor (Ref: Form_27Q_Correction_BH_Fields.md)
            bh[70] = ''                              // 70. (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[71] = ''                              // 71. (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            bh[72] = ''                              // 72. (No Value per Ref: Form_27Q_Correction_BH_Fields.md)
            return bh
        }

        // Calculate highest challan record number in original conso file
        const maxConsoChallanRecordNo = Math.max(0, ...challanData
            .filter(c => c.source === 'conso' || (c.recordNo && parseInt(c.recordNo, 10) > 0))
            .map(c => parseInt(c.recordNo || 0, 10)))
        let nextAddedChallanNo = maxConsoChallanRecordNo + 1
        const assignedChallanRecordNos = new Map()

        const getChallanRecordNo = (challan) => {
            if (challan.recordNo && parseInt(challan.recordNo, 10) > 0) {
                return parseInt(challan.recordNo, 10)
            }
            if (!assignedChallanRecordNos.has(challan.id)) {
                assignedChallanRecordNos.set(challan.id, nextAddedChallanNo++)
            }
            return assignedChallanRecordNos.get(challan.id)
        }

        // Per-challan counter for additions starting after the last record no of DD in that challan
        const nextDeducteeNoByChallan = {}
        const getNextDeducteeNo = (challanId) => {
            if (nextDeducteeNoByChallan[challanId] === undefined) {
                const existingConsoDDs = tdsData.filter(t => t.challanId == challanId && t.source === 'conso' && t.recordNo)
                const maxNo = Math.max(0, ...existingConsoDDs.map(t => parseInt(t.recordNo, 10)))
                nextDeducteeNoByChallan[challanId] = maxNo + 1
            }
            return nextDeducteeNoByChallan[challanId]++
        }

        // ─────────────────────────────────────────────────────────────────────────
        // Helper: emit CD + DD rows for one challan group
        // ─────────────────────────────────────────────────────────────────────────
        const emitCDDD = (challan, dds, batchNo, challanRecordNo, isChallanUpdation, batchType) => {
            const cd = []
            const eduCess = parseFloat(challan.educationCess || 0) + parseFloat(challan.higherEducationCess || 0)

            const getOldVal = (origVal1, origVal2, fallbackVal1, fallbackVal2) => {
                if (origVal1 !== undefined && origVal1 !== null && origVal1 !== '' && !isNaN(Number(origVal1))) return parseFloat(origVal1)
                if (origVal2 !== undefined && origVal2 !== null && origVal2 !== '' && !isNaN(Number(origVal2))) return parseFloat(origVal2)
                if (fallbackVal1 !== undefined && fallbackVal1 !== null && fallbackVal1 !== '' && !isNaN(Number(fallbackVal1))) return parseFloat(fallbackVal1)
                if (fallbackVal2 !== undefined && fallbackVal2 !== null && fallbackVal2 !== '' && !isNaN(Number(fallbackVal2))) return parseFloat(fallbackVal2)
                return 0
            }

            let cdTdsSum = 0
            let cdSurchSum = 0
            let cdCessSum = 0
            let cdTotalSum = 0

            if (batchType === 'C3' || batchType === 'C5') {
                dds.forEach(tds => {
                    const isNew = tds.source !== 'conso'
                    let mode = 'U'
                    if (isNew) mode = 'A'
                    else if (tds.consoMode === 'F') mode = 'F'

                    const tdsVal = parseFloat(tds.tdsAmount || 0)
                    const surchargeVal = parseFloat(tds.surcharge || 0)
                    const cessVal = parseFloat(tds.cess || 0)
                    const totTax = tdsVal + surchargeVal + cessVal

                    if (mode === 'A') {
                        cdTdsSum += tdsVal
                        cdSurchSum += surchargeVal
                        cdCessSum += cessVal
                        cdTotalSum += totTax
                    } else if (mode === 'U') {
                        const originalTds = originalTdsData 
                            ? (originalTdsData.find(o => o.id === tds.id) || originalTdsData.find(o => o.recordNo && o.recordNo == tds.recordNo && o.challanId == tds.challanId))
                            : null

                        const oldTdsVal = getOldVal(originalTds?.originalTdsAmount, tds.originalTdsAmount, originalTds?.tdsAmount, tds.tdsAmount)
                        const oldSurchVal = getOldVal(originalTds?.originalSurcharge, tds.originalSurcharge, originalTds?.surcharge, tds.surcharge)
                        const oldCessVal = getOldVal(originalTds?.originalCess, tds.originalCess, originalTds?.cess, tds.cess)
                        const oldTotTax = (originalTds?.originalTotalTax !== undefined && originalTds.originalTotalTax !== null && originalTds.originalTotalTax !== '' && !isNaN(Number(originalTds.originalTotalTax)))
                            ? parseFloat(originalTds.originalTotalTax)
                            : (tds.originalTotalTax !== undefined && tds.originalTotalTax !== null && tds.originalTotalTax !== '' && !isNaN(Number(tds.originalTotalTax))
                                ? parseFloat(tds.originalTotalTax)
                                : (oldTdsVal + oldSurchVal + oldCessVal))

                        cdTdsSum += (tdsVal - oldTdsVal)
                        cdSurchSum += (surchargeVal - oldSurchVal)
                        cdCessSum += (cessVal - oldCessVal)
                        cdTotalSum += (totTax - oldTotTax)
                    }
                })
            } else {
                cdTdsSum = dds.reduce((a, b) => a + parseFloat(b.tdsAmount || 0), 0)
                cdSurchSum = dds.reduce((a, b) => a + parseFloat(b.surcharge || 0), 0)
                cdCessSum = dds.reduce((a, b) => a + parseFloat(b.cess || 0), 0)
                cdTotalSum = cdTdsSum + cdSurchSum + cdCessSum
            }

            cd[1] = lineNumber                       // 1. Line Number (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[2] = 'CD'                             // 2. Record Type (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[3] = String(batchNo)                  // 3. Batch Number (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[4] = challanRecordNo                  // 4. Challan Record Number (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[5] = dds.length                       // 5. Count of Deductee Records (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[6] = 'N'                              // 6. NIL Challan Indicator (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[7] = isChallanUpdation ? '1' : '0'    // 7. Challan Updation Indicator (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[8] = ''                               // 8. Filler (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            cd[9] = ''                               // 9. Filler (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            cd[10] = ''                              // 10. Filler (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            cd[11] = challan.originalChallanNo || ''   // 11. Last Bank Challan Number (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[12] = challan.challanSerialNo || ''   // 12. Bank Challan No. (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[13] = ''                              // 13. Last DDO Serial No. (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            cd[14] = ''                              // 14. DDO Serial No. (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            cd[15] = challan.originalBsrCode || ''     // 15. Last Bank Branch Code (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[16] = challan.bsrCode || ''           // 16. Bank Branch Code (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[17] = challan.originalDateOfDeposit || '' // 17. Last Date of Bank Challan (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[18] = formatDate(challan.dateOfDeposit) // 18. Date of Bank Challan (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[19] = ''                              // 19. Filler (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            cd[20] = ''                              // 20. Filler (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            cd[21] = challan.section || ''           // 21. Section (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[22] = isChallanUpdation ? formatDecimalAmount(challan.tdsAmount) : '' // 22. TDS Income Tax (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[23] = isChallanUpdation ? formatDecimalAmount(challan.surcharge) : '' // 23. TDS Surcharge (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[24] = isChallanUpdation ? formatDecimalAmount(eduCess) : ''    // 24. TDS Cess (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[25] = isChallanUpdation ? formatDecimalAmount(challan.interest) : '' // 25. TDS Interest (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[26] = isChallanUpdation ? formatDecimalAmount(challan.other) : '' // 26. TDS Others (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[27] = formatDecimalAmount(challan.totalAmount) // 27. Total Deposit Amount (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[28] = formatDecimalAmount(challan.totalAmount) // 28. Last Total Deposit Amount (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[29] = formatDecimalAmount(cdTotalSum) // 29. Total Tax Deposit per Annexure (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[30] = formatDecimalAmount(cdTdsSum) // 30. Sum DD Income Tax (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[31] = formatDecimalAmount(cdSurchSum) // 31. Sum DD Surcharge (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[32] = formatDecimalAmount(cdCessSum)    // 32. Sum DD Cess (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[33] = formatDecimalAmount(cdTotalSum) // 33. Sum DD Total TDS (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[34] = formatDecimalAmount(challan.interest || 0) // 34. TDS Interest (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[35] = formatDecimalAmount(challan.other || 0)    // 35. TDS Others (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[36] = ''                              // 36. Cheque/DD No. (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            cd[37] = challan.bookEntry ? 'Y' : 'N'   // 37. By Book Entry / Cash (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[38] = ''                              // 38. Remarks (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            cd[39] = formatDecimalAmount(challan.feesAmount) // 39. Fee (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[40] = isChallanUpdation ? formatMinorHead27Q(challan.minorHead) : '' // 40. Minor Head (Ref: Form_27Q_Correction_FH_Fields.md)
            cd[41] = ''                              // 41. Record Hash (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
            fileContent += cd.slice(1).join('^') + '\n'
            lineNumber++

            // DD records
            // Ensure records are in increasing order of their original record number (for Updates)
            // New records (Additions) will follow at the end.
            const sortedDds = [...dds].sort((a, b) => {
                const aNo = a.source === 'conso' ? parseInt(a.recordNo || 0) : 999999
                const bNo = b.source === 'conso' ? parseInt(b.recordNo || 0) : 999999
                return aNo - bNo
            })

            const seenRecordNos = new Set()
            sortedDds.forEach((tds) => {
                const dd = []
                const rate = parseFloat(tds.rateOfTax || 0)
                const tdsVal = parseFloat(tds.tdsAmount || 0)
                const surchargeVal = parseFloat(tds.surcharge || 0)
                const cessVal = parseFloat(tds.cess || 0)
                const totalTax = tdsVal + surchargeVal + cessVal

                const isNew = tds.source !== 'conso'
                let mode = 'U'
                if (isNew) mode = 'A'
                else if (tds.consoMode === 'F') mode = 'F'

                const originalTds = originalTdsData ? originalTdsData.find(o => o.id === tds.id) : null
                let recordNo = isNew ? getNextDeducteeNo(challan.id) : (parseInt(tds.recordNo, 10) || tds.recordNo)
                if (!recordNo || seenRecordNos.has(String(recordNo))) {
                    recordNo = getNextDeducteeNo(challan.id)
                }
                seenRecordNos.add(String(recordNo))

                dd[1] = lineNumber                   // 1. Line Number (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[2] = 'DD'                         // 2. Record Type (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[3] = String(batchNo)              // 3. Batch Number (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[4] = challanRecordNo              // 4. Challan Record Number (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[5] = recordNo                     // 5. Deductee Record Number (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[6] = mode                         // 6. Mode (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[7] = ''                           // 7. Employee Serial No (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
                dd[8] = tds.deducteeCode === '01' ? '1' : '2' // 8. Deductee Code (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[9] = mode === 'U' ? (tds.originalPan || '') : '' // 9. Last Deductee PAN (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[10] = String(tds.panOfDeductee || '').replace(/[\r\n]/g, '').trim()     // 10. Deductee PAN (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[11] = mode === 'U' ? (tds.originalRefNo || '') : '' // 11. Last PAN Ref. No. (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[12] = tds.deducteeReferenceNo || '' // 12. PAN Ref. No. (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[13] = padString(tds.firstName || '', 75)    // 13. Name of Deductee (Ref: Form_27Q_Correction_FH_Fields.md)

                const getOrigTax = (item) => {
                  if (!item) return 0
                  if (item.originalTotalTax !== undefined && item.originalTotalTax !== null && item.originalTotalTax !== '' && !isNaN(Number(item.originalTotalTax))) {
                    return parseFloat(item.originalTotalTax)
                  }
                  const t = parseFloat(item.tdsAmount || 0)
                  const s = parseFloat(item.surcharge || 0)
                  const c = parseFloat(item.cess || 0)
                  return t + s + c
                }

                const getOrigTaxDeposited = (item) => {
                  if (!item) return 0
                  if (item.originalTotalTaxDeposited !== undefined && item.originalTotalTaxDeposited !== null && item.originalTotalTaxDeposited !== '' && !isNaN(Number(item.originalTotalTaxDeposited))) {
                    return parseFloat(item.originalTotalTaxDeposited)
                  }
                  return getOrigTax(item)
                }

                const lastTotalTax = originalTds ? getOrigTax(originalTds) : getOrigTax(tds)
                const lastTotalTaxDeposited = originalTds ? getOrigTaxDeposited(originalTds) : getOrigTaxDeposited(tds)

                dd[14] = formatDecimalAmount(tdsVal) // 14. TDS Income Tax (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[15] = formatDecimalAmount(surchargeVal) // 15. TDS Surcharge (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[16] = formatDecimalAmount(cessVal) // 16. Health & Edu Cess (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[17] = formatDecimalAmount(totalTax) // 17. Total TDS (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[18] = mode === 'U' ? formatDecimalAmount(lastTotalTax) : '' // 18. Last Total TDS (before updation)
                dd[19] = formatDecimalAmount(totalTax) // 19. Total Tax Deposited (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[20] = mode === 'U' ? formatDecimalAmount(lastTotalTaxDeposited) : '' // 20. Last Total Tax Deposited (before updation)
                dd[21] = ''                          // 21. Total Value of Purchase (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
                dd[22] = formatDecimalAmount(tds.amountOfPayment) // 22. Amount of Payment (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[23] = formatDate(tds.dateOfPayment) // 23. Date of Payment (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[24] = totalTax > 0 ? formatDate(tds.dateOfDeduction) : '' // 24. Date of Deduction (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[25] = ''                          // 25. Date of Deposit (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
                dd[26] = rate.toFixed(4)             // 26. Rate of Deduction (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[27] = ''                          // 27. Grossing up Indicator (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
                dd[28] = ''                          // 28. Book Entry (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
                dd[29] = ''                          // 29. Certificate Date (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
                dd[30] = isNew ? (tds.reasonForNonDeduction || '') : (originalTds?.reasonForNonDeduction || '') // 30. Remarks 1 (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[31] = tds.residentNonResident || '' // 31. Resident/Non-resident (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[32] = tds.permanentEstablishment || '' // 32. Permanent Establishment (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[33] = tds.sectionCode || ''       // 33. Section Code (Ref: Form_27Q_Correction_FH_Fields.md)
                dd[34] = tds.certificateNo197 || ''  // 34. Certificate No u/s 197 (Ref: Form_27Q_Correction_FH_Fields.md)
                for (let i = 35; i <= 53; i++) dd[i] = '' // 35-53 (Fillers, No Value per Ref: Form_27Q_Correction_FH_Fields.md)
                dd[54] = ''                          // 54. Record Hash (No Value per Ref: Form_27Q_Correction_FH_Fields.md)
                fileContent += dd.slice(1).join('^') + '\n'
                lineNumber++
            })
        }

        // ─────────────────────────────────────────────────────────────────────────
        // STEP 4: Emit all batches
        // ─────────────────────────────────────────────────────────────────────────
        const bhC = isBhChanged()
        batches.forEach((batch, batchIdx) => {
            const batchNo = batchIdx + 1
            const batchTotalAmt = batch.groups.reduce((sum, g) => sum + parseFloat(g.challan.totalAmount || 0), 0)
            const includesBhChanges = batch.type === 'C5' ? false : bhC
            const cdCount = batch.groups.length

            const bhArr = buildBH(batchNo, batch.type, includesBhChanges, batchTotalAmt)
            bhArr[4] = (batch.type === 'C1' || batch.type === 'C4') ? '' : cdCount
            fileContent += bhArr.slice(1).join('^') + '\n'
            lineNumber++

            if (batch.type === 'C1' || batch.type === 'C4') return

            batch.groups.forEach(g => {
                const dds = batch.type === 'C5' ? g.panOnlyDDs : g.otherDDs
                const isChallanUpd = g.challanChanged && batch.type !== 'C5'
                const challanRecordNo = getChallanRecordNo(g.challan)
                emitCDDD(g.challan, dds, batchNo, challanRecordNo, isChallanUpd, batch.type)
            })
        })

        return fileContent
    }


    
    const handleCsiFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setCsiFile(e.target.files[0])
            setShowCsiUploadPopup(false)
            executeValidation(e.target.files[0])
        }
    }

    const handleCsiDownload = async () => {
        if (!downloadPassword) {
            toast.error('Please enter Income Tax Portal Password');
            return;
        }
        setIsDownloadingCsi(true);
        try {
            const { from, to } = challanDateRange;
            if (!from || !to) {
                toast.error('Could not determine date range from challans. Please upload CSI manually.');
                setIsDownloadingCsi(false);
                return;
            }
            const response = await axios.post('/api/login-income-tax', {
                credentials: {
                    tan: profileData?.section1?.taxDeduction || profileData?.section1?.tan,
                    password: downloadPassword
                },
                dateRange: { from, to }
            });

            if (response.data.success && response.data.csiContent) {
                toast.success('CSI File Downloaded Successfully!');
                setShowDownloadPrompt(false);
                if (typeof setDownloadPassword === 'function') setDownloadPassword('');
                
                const binaryString = window.atob(response.data.csiContent.replace(/\s/g, ''));
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                const file = new File([bytes], response.data.fileName || 'downloaded.csi', { type: 'text/plain' });
                if (typeof setCsiFile === 'function') setCsiFile(file);
                if (typeof executeValidation === 'function') executeValidation(file);
            } else {
                const errMsg = response.data.error || 'Failed to download CSI file. Please check password.';
                toast.error(errMsg);
            }
    } catch (error) {
            console.error('CSI Download Error:', error);
            toast.error('An error occurred during download');
        } finally {
            setIsDownloadingCsi(false);
        }
    };

    const handleProfilePrefill = async () => {
        if (!prefillPassword) {
            toast.error('Portal password is required');
            return;
        }
        setIsExtractingProfile(true);
        try {
            const { success, data, error } = await extractProfileDataApi({
                tan: profileData.section1?.taxDeduction,
                password: prefillPassword
            });
            if (success && data) {
                const newData = { ...profileData };
                if (data.pan) { newData.section1.permanentAccountNumber = data.pan; if (newData.section3) newData.section3.permanentAccountNumber = data.pan; }
                if (data.name) newData.section2.name = data.name;
                if (data.keyPerson) { if (data.keyPerson.name) newData.section3.name = data.keyPerson.name; if (data.keyPerson.pan) newData.section3.permanentAccountNumber = data.keyPerson.pan; }
                if (data.email) { newData.section2.email = data.email; if (newData.section3) newData.section3.email = data.email; }
                if (data.mobile && newData.section3) newData.section3.mobileNo = data.mobile;
                setProfileData(newData);
                // Cloud sync via updateProfileData);
                toast.success('Profile data pre-filled successfully!');
                setShowPrefillPrompt(false);
                setPrefillPassword('');
            } else {
                toast.error(error || 'Extraction failed');
            }
        } catch (error) {
            toast.error('Extraction Failed: ' + (error.message));
        } finally {
            setIsExtractingProfile(false);
        }
    };

const parseConsoFile = (consoText) => {
        try {
            const lines = consoText.split('\n')

            // Validate BH record form type
            const bhLine = lines.find(l => {
                const p = l.split('^')
                return p[1] === 'BH'
            })

            if (bhLine) {
                const bhParts = bhLine.split('^')
                const formInConso = (bhParts[4] || '').toUpperCase().trim()
                if (formInConso && formInConso !== '27Q' && formInConso !== '144') {
                    toast.error(`Invalid Conso File! Expected Form 27Q, but file contains Form ${formInConso}.`)
                    alert(`Invalid Conso File!\n\nThis form is Form 27Q, but the uploaded Conso file belongs to Form ${formInConso}.\nPlease upload the correct Form 27Q Conso file.`)
                    return
                }
            }

            const newChallans = []
            const newTdsData = []
            let currentChallan = null
            let rowIndex = 1

            lines.forEach(line => {
                if (!line.trim()) return
                const parts = line.split('^')
                const recordType = parts[1]

                if (recordType === 'BH') {
                    const getMappedState = (code) => {
                        if (!code) return '';
                        const padded = code.padStart(2, '0');
                        return reverseStateCodes[padded] || reverseStateCodes[code] || '';
                    };
                    const bhData = {
                        section1: {
                            taxDeduction: parts[12] || '', // TAN (Field 13)
                            permanentAccountNumber: parts[14] || '', // PAN (Field 15)
                            typeOfDeduction: parts[31] || '', // Type/Status (Field 32)
                            receiptNoOriginal: parts[7] || '', // Token No (Field 8)
                            receiptNoEarlier: parts[8] || '', // Prev Token No (Field 9)
                            isEarlierReturnFiled: parts[51] === 'Y' ? 'Yes' : 'No' // Field 52
                        },
                        section2: {
                            name: parts[18] || '', // Field 19
                            branchDivision: parts[19] || '', // Field 20
                            flatNo: parts[20] || '', // Field 21
                            nameOfPremises: parts[21] || '', // Field 22
                            roadStreet: parts[22] || '', // Field 23
                            areaLocality: parts[23] || '', // Field 24
                            townCity: parts[24] || '', // Field 25
                            state: getMappedState(parts[25]), // Field 26
                            pinCode: parts[26] || '', // Field 27
                            email: parts[27] || '', // Field 28
                            stdCode: parts[28] || '', // Field 29
                            telephoneNo: parts[29] || '', // Field 30
                            gstin: parts[68] || '', // Field 69
                        },
                        section3: {
                            name: parts[32] || '', // Field 33
                            designation: parts[33] || '', // Field 34
                            flatNo: parts[34] || '', // Field 35
                            nameOfPremises: parts[35] || '', // Field 36
                            roadStreet: parts[36] || '', // Field 37
                            areaLocality: parts[37] || '', // Field 38
                            townCity: parts[38] || '', // Field 39
                            state: getMappedState(parts[39]), // Field 40
                            pinCode: parts[40] || '', // Field 41
                            email: parts[41] || '', // Field 42
                            mobileNo: parts[47] || '', // Field 48 (TRACES Conso)
                            stdCode: parts[43] || '', // Field 44
              telephone: parts[44] || '', // Field 45
                            telephoneAlternate: parts[45] || '', // Field 46
                            permanentAccountNumber: parts[58] || '', // Field 59
                            hasAddressChanged: parts[46] === 'Y' ? 'Yes' : 'No', // Field 47
                            sameAsAbove: false
                        }
                    }
                    setProfileData(bhData)
                    setOriginalProfileData(JSON.parse(JSON.stringify(bhData)))
                    // Cloud sync via updateProfileData)
                    setBatchNumber(parts[2] || '1')
                    localStorage.setItem('tds27QBatchNumber', parts[2] || '1')
                } else if (recordType === 'CD') {
                    const challan = {
                        id: Date.now() + rowIndex++,
                        challanSerialNo: parts[11] || '',
                        bsrCode: parts[15] || '',
                        dateOfDeposit: parts[17] ? `${parts[17].slice(4, 8)}-${parts[17].slice(2, 4)}-${parts[17].slice(0, 2)}` : '',
                        minorHead: parts[39] || '200',
                        tdsAmount: parseFloat(parts[21] || 0),
                        surcharge: parseFloat(parts[22] || 0),
                        educationCess: parseFloat(parts[23] || 0),
                        interest: parseFloat(parts[24] || 0),
                        other: parseFloat(parts[25] || 0),
                        totalAmount: parseFloat(parts[26] || 0),
                        feesAmount: parseFloat(parts[38] || 0),
                        bookEntry: parts[36] === 'Y',
                        recordNo: parts[3] ? parseInt(parts[3], 10) : '',
                        source: 'conso',
                        higherEducationCess: 0,
                        // Original fields for correction return "Last" values
                        originalChallanNo: parts[11] || '',
                        originalBsrCode: parts[15] || '',
                        originalDateOfDeposit: parts[17] || '', // Already DDMMYYYY in conso
                        originalTotalAmount: parts[26] || ''
                    }
                    currentChallan = challan
                    newChallans.push(challan)
                } else if (recordType === 'DD') {
                    if (!currentChallan) return
                    const fullName = (parts[12] || '').trim();
                    const origTds = parseFloat(parts[13] || 0)
                    const origSurch = parseFloat(parts[14] || 0)
                    const origCess = parseFloat(parts[15] || 0)
                    const computedTotalTax = origTds + origSurch + origCess
                    const origTotalTaxFromField = (parts[16] !== undefined && parts[16] !== '') ? parseFloat(parts[16]) : computedTotalTax
                    const origTotalTaxDepositedFromField = (parts[18] !== undefined && parts[18] !== '') ? parseFloat(parts[18]) : origTotalTaxFromField

                    const deductee = {
                        id: Date.now() + rowIndex++,
                        challanId: currentChallan.id,
                        deducteeCode: parts[7] || '02',
                        panOfDeductee: parts[9] || '',
                        originalPan: parts[9] || '',
                        firstName: fullName,
                        middleName: '',
                        lastName: '',
                        amountOfPayment: parseFloat(parts[21] || 0),
                        dateOfPayment: parts[22] ? `${parts[22].slice(4, 8)}-${parts[22].slice(2, 4)}-${parts[22].slice(0, 2)}` : '',
                        dateOfDeduction: parts[23] ? `${parts[23].slice(4, 8)}-${parts[23].slice(2, 4)}-${parts[23].slice(0, 2)}` : '',
                        rateOfTax: parseFloat(parts[25] || 0).toFixed(2),
                        tdsAmount: origTds,
                        surcharge: origSurch,
                        cess: origCess,
                        sectionCode: parts[32] || parts[33] || '',
                        reasonForNonDeduction: parts[29] || '',
                        deducteeReferenceNo: parts[11] || '',
                        certificateNo197: parts[34] || '',       // Field 34 = Certificate No u/s 197
                        source: 'conso',
                        recordNo: parts[4] || '',
                        challanRecordNo: parts[3] || '',
                        consoMode: parts[5] || '',
                        originalTotalTax: origTotalTaxFromField,
                        originalTotalTaxDeposited: origTotalTaxDepositedFromField,
                        originalTdsAmount: origTds,
                        originalSurcharge: origSurch,
                        originalCess: origCess,
                        originalRefNo: parts[11] || parts[10] || parts[4] || ''
                    }
                    newTdsData.push(deductee)
                }
            })

            setChallanData(newChallans)
            setStorageItem('tds27QChallanData', newChallans)
            setOriginalChallanData(JSON.parse(JSON.stringify(newChallans)))
            setStorageItem('tds27QOriginalChallanData', newChallans)

            setTdsData(newTdsData)
            setStorageItem('tds27QTdsData', newTdsData)
            setOriginalTdsData(JSON.parse(JSON.stringify(newTdsData)))
            setStorageItem('tds27QOriginalTdsData', newTdsData)

            toast.success('Conso File Uploaded and Parsed!')
        } catch (err) {
            console.error(err)
            toast.error('Error parsing conso file')
        }
    }

    const handleConsoFileUpload = (e) => {
        const file = e.target.files[0]
        if (!file) return
        const reader = new FileReader()
        reader.onload = (ev) => {
            setConsoFileContent(ev.target.result)
            parseConsoFile(ev.target.result)
        }
        reader.readAsText(file)
    }

    ;

    

    

    // Effect for Prepare Return signal
    

        const today = new Date();


    const currMonth = today.getMonth(); // 0=Jan, 3=Apr


    const currYear = today.getFullYear();


    const currentFyStart = currMonth >= 3 ? currYear : currYear - 1;


    


    const financialYearOptions = [];


    for (let start = currentFyStart; start >= 2023; start--) {


        financialYearOptions.push(`${start}-${(start + 1).toString().slice(-2)}`);


    }
    const quarterOptions = ['Q1', 'Q2', 'Q3', 'Q4'];
    const formOptions = ['27Q'];

    const handleClearData = () => {
        if (window.confirm('Are you sure you want to clear all data? This action cannot be undone.')) {
            const initialProfile = {
                section1: {
                    taxDeduction: '',
                    permanentAccountNumber: '',
                    typeOfDeduction: '',
                    receiptNoOriginal: '',
                    receiptNoEarlier: '',
                    isEarlierReturnFiled: 'No'
                },
                section2: {
                    name: '',
                    branchDivision: '',
                    flatNo: '',
                    nameOfPremises: '',
                    roadStreet: '',
                    areaLocality: '',
                    townCity: '',
                    pinCode: '',
                    state: '',
                    email: '',
                    stdCode: '',
                    telephoneNo: ''
                },
                section3: {
                    sameAsAbove: false,
                    name: '',
                    designation: '',
                    permanentAccountNumber: '',
                    nameOfPremises: '',
                    flatNo: '',
                    areaLocality: '',
                    roadStreet: '',
                    pinCode: '',
                    townCity: '',
                    telephone: '',
                    telephoneAlternate: '',
                    state: '',
                    email: '',
                    emailAlternate: '',
                    mobileNo: '',
                    hasAddressChanged: '',
                    hasRegularStatement: ''
                }
            }

            setChallanData([])
            setTdsData([])
            setOriginalTdsData([])
            setProfileData(initialProfile)

            localStorage.removeItem(getLegacyStorageKey('27Q', 'ChallanData'))
            localStorage.removeItem(getLegacyStorageKey('27Q', 'TdsData'))
            localStorage.removeItem(getLegacyStorageKey('27Q', 'ProfileData'))
            localStorage.removeItem(getLegacyStorageKey('27Q', 'OriginalTdsData'))

            toast.success('All data cleared successfully')
        }
    }

    // ... Render ...
    return (
        <div className="min-h-screen bg-gray-50 w-full overflow-x-hidden">
            <ToastContainer position="top-right" autoClose={3000} />

            <header className={`bg-white shadow-sm border-b transition-all duration-300 ${!isMobile ? (sidebarState.isExpanded ? 'ml-64' : 'ml-14') : ''}`} style={{
                width: !isMobile ? (sidebarState.isExpanded ? 'calc(100% - 16rem)' : 'calc(100% - 3.5rem)') : '100%'
            }}>
                <div className="w-full px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-16 relative">
                        <div className="flex items-center">
                            <FileText className="w-6 h-6 mr-2 text-blue-600" />
                        </div>
                        <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <h1 className="text-xl font-bold text-gray-800">Form 27Q (Non-Residents)</h1>
                        </div>
                        <button
                            onClick={handleClearData}
                            className="flex items-center text-red-600 hover:text-red-700 px-3 py-2 rounded-md text-sm font-medium hover:bg-red-50 transition-colors"
                        >
                            <Trash2 className="w-4 h-4 mr-2" />
                            Clear Data
                        </button>
                    </div>
                </div>
            </header>

            <main className={`py-4 px-2 sm:px-4 lg:px-6 transition-all duration-300 ${!isMobile ? (sidebarState.isExpanded ? 'ml-64' : 'ml-14') : ''}`} style={{
                width: !isMobile ? (sidebarState.isExpanded ? 'calc(100% - 16rem)' : 'calc(100% - 3.5rem)') : '100%',
                maxWidth: '100%',
                overflowX: 'hidden',
                minHeight: 'calc(100vh - 4rem)'
            }}>
                <div className="p-4 md:p-8 pt-6">


                    {/* Selection Controls */}
                    <div className="bg-white rounded-lg shadow-sm p-4 mb-6 border border-gray-200">
                        <div className="flex flex-wrap gap-4 items-end">
                            <div className="flex-1 min-w-[180px] w-full">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Financial Year <span className="text-red-500">*</span>
                                </label>
                                <select
                                    value={selectedFinancialYear}
                                    onChange={(e) => {
                                        const newYear = e.target.value;
                  setSelectedFinancialYear(newYear);
                  localStorage.setItem('tdsFinancialYear', newYear);
                  
                  // Auto-update selectedForm if it doesn't match the year's format
                  if (newYear) {
                    const isNewFormat = parseInt(newYear.split('-')[0]) >= 2026;
                    setSelectedForm(prevForm => {
                      const f = prevForm;
                      const mapped = isNewFormat 
                        ? (f === '24Q' ? '138' : (f === '26Q' || f === '140') ? '140' : f === '27Q' ? '144' : f === '27EQ' ? '143' : f === '24Q4' ? '24Q4' : f)
                        : (f === '138' ? '24Q' : (f === '140' || f === '26Q') ? '26Q' : f === '144' ? '27Q' : f === '143' ? '27EQ' : f === '24Q4' ? '24Q4' : f);
                      if (mapped !== prevForm) {
                        localStorage.setItem('tdsForm', mapped);
                        return mapped;
                      }
                      return prevForm;
                    });
                  }
                                    }}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                >
                                    <option value="">Select Financial Year</option>
                                    {financialYearOptions.map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex-1 min-w-[180px] w-full">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Quarter <span className="text-red-500">*</span>
                                </label>
                                <select
                                    value={selectedQuarter}
                                    onChange={(e) => {
                                        setSelectedQuarter(e.target.value)
                                        localStorage.setItem('tdsQuarter', e.target.value)
                                    }}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                >
                                    <option value="">Select Quarter</option>
                                    {quarterOptions.map(quarter => (
                                        <option key={quarter} value={quarter}>{quarter}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex-1 min-w-[180px] w-full">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Form Type <span className="text-red-500">*</span>
                                </label>
                                <select
                                    value={selectedForm}
                                    onChange={(e) => {
                                        const newForm = e.target.value;
                                        setSelectedForm(newForm)
                                        localStorage.setItem('tdsForm', newForm)
                                    }}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                >
                                    {['24Q', '26Q', '27Q', '27EQ'].map(form => (
                                        <option key={form} value={form}>
                                            {selectedFinancialYear && parseInt(selectedFinancialYear.split('-')[0]) >= 2026 
                                              ? (form === '24Q' ? '138' : form === '26Q' ? '140' : form === '27Q' ? '144' : form === '27EQ' ? '143' : form)
                                              : form}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex-1 min-w-[180px] w-full">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Return Type <span className="text-red-500">*</span>
                                </label>
                                <select
                                    value={selectedReturnType}
                                    onChange={(e) => {
                                        setSelectedReturnType(e.target.value)
                                        localStorage.setItem('SELECTED_RETURN_TYPE', e.target.value)
                                    }}
                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                >
                                    <option value="">Select Return Type</option>
                                    <option value="Regular">Regular</option>
                                    <option value="Correction">Correction</option>
                                </select>
                            </div>

                            <div className="flex-1 min-w-[200px] w-full flex items-center mb-1">
                                <button
                                    onClick={() => {
                                        const targetForm = selectedForm ? selectedForm.toLowerCase() : '27q';
                                        const isCorrection = selectedReturnType === 'Correction';
                                        const suffix = isCorrection ? '-correction' : '';
                                        const targetPath = `/tds-dashboard/${targetForm}${suffix}`;
                                        if (location.pathname !== targetPath) {
                                            navigate(targetPath);
                                            toast.success('Selection Applied');
                                        } else {
                                            toast.success('Selection Applied');
                                        }
                                    }}
                                    className="w-full px-8 py-2.5 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg hover:from-orange-700 hover:to-red-700 transition-all font-semibold shadow-lg hover:shadow-orange-200"
                                >
                                    Apply Selection
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Receipt Details Section (Conditional) */}
                    {(selectedReturnType === 'Correction' || selectedReturnType === 'Regular') && (
                        <div className="bg-white rounded-xl shadow-md p-6 mb-8 border border-gray-100 overflow-hidden relative">
                            <div className="absolute top-0 left-0 w-2 h-full bg-orange-500"></div>
                            <h3 className="text-lg font-bold text-gray-800 mb-6 flex items-center">
                                <Building2 className="w-5 h-5 mr-2 text-orange-600" />
                                Statement Receipt Details <span className="text-red-500 ml-1">*</span>
                            </h3>

                            <div className="space-y-6">
                                {/* REVISED RETURN CASE - PREMIUM UI */}
                                {selectedReturnType === 'Correction' && (
                                    <div className="bg-orange-50 rounded-xl p-6 border border-orange-100">
                                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
                                            {/* Conso Upload Area */}
                                            <div className="lg:col-span-1">
                                                <div className="flex flex-col items-center text-center">
                                                    <input
                                                        type="file"
                                                        accept=".tds"
                                                        onChange={handleConsoFileUpload}
                                                        className="hidden"
                                                        id="conso-upload-premium"
                                                    />
                                                    <label
                                                        htmlFor="conso-upload-premium"
                                                        className="group relative flex flex-col items-center justify-center w-full h-40 border-2 border-dashed border-orange-300 rounded-2xl bg-white hover:bg-orange-50 hover:border-orange-500 transition-all cursor-pointer overflow-hidden shadow-sm"
                                                    >
                                                        {consoFileContent ? (
                                                            <motion.div initial={{ scale: 0.8 }} animate={{ scale: 1 }} className="flex flex-col items-center text-green-600">
                                                                <div className="bg-green-100 p-3 rounded-full mb-2">
                                                                    <FileText className="w-8 h-8" />
                                                                </div>
                                                                <span className="text-sm font-bold">Conso File Ready</span>
                                                                <span className="text-xs text-green-500 mt-1">Click to Replace</span>
                                                            </motion.div>
                                                        ) : (
                                                            <div className="flex flex-col items-center text-gray-500">
                                                                <div className="bg-orange-100 p-3 rounded-full mb-3 group-hover:bg-orange-200 transition-colors">
                                                                    <Upload className="w-8 h-8 text-orange-600" />
                                                                </div>
                                                                <span className="text-sm font-bold text-gray-700 group-hover:text-orange-700">Upload Conso File</span>
                                                                <span className="text-[10px] text-gray-400 mt-1 uppercase tracking-wider font-medium">Click to browse (.tds)</span>
                                                            </div>
                                                        )}

                                                        {/* Animated background glow */}
                                                        <div className="absolute inset-0 bg-blue-400 opacity-0 group-hover:opacity-5 transition-opacity pointer-events-none"></div>
                                                    </label>

                                                    <p className="mt-3 text-xs text-gray-500 text-center flex items-center">
                                                        <User className="w-3 h-3 mr-1" />
                                                        Upload Consolidated .tds file from TRACES
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Auto-filled Fields */}
                                            <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
                                                <div className="space-y-2">
                                                    <label className="text-xs font-bold text-orange-700 uppercase tracking-wider">
                                                        Receipt No. of Original Return
                                                    </label>
                                                    <div className="relative">
                                                        <input
                                                            type="text"
                                                            value={profileData?.section1?.receiptNoOriginal || ''}
                                                            disabled
                                                            className="w-full px-4 py-3 bg-white border border-orange-200 rounded-xl text-gray-700 font-medium shadow-sm cursor-not-allowed"
                                                            placeholder="Waiting for Conso upload..."
                                                        />
                                                        {profileData?.section1?.receiptNoOriginal && (
                                                            <div className="absolute right-3 top-1/2 -translate-y-1/2 bg-green-100 text-green-700 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                                                Verified
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="space-y-2">
                                                    <label className="text-xs font-bold text-orange-700 uppercase tracking-wider">
                                                        Receipt No. of Earlier Statement
                                                    </label>
                                                    <div className="relative">
                                                        <input
                                                            type="text"
                                                            value={profileData?.section1?.receiptNoEarlier || ''}
                                                            disabled
                                                            className="w-full px-4 py-3 bg-white border border-orange-200 rounded-xl text-gray-700 font-medium shadow-sm cursor-not-allowed"
                                                            placeholder="Waiting for Conso upload..."
                                                        />
                                                        {profileData?.section1?.receiptNoEarlier && (
                                                            <div className="absolute right-3 top-1/2 -translate-y-1/2 bg-green-100 text-green-700 text-[10px] px-2 py-0.5 rounded-full font-bold">
                                                                Verified
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="md:col-span-2 flex items-center p-3 bg-white rounded-lg border border-orange-100 shadow-sm">
                                                    <div className="bg-orange-100 p-2 rounded-lg mr-3">
                                                        <ArrowLeft className="w-4 h-4 text-orange-600" />
                                                    </div>
                                                    <p className="text-xs text-gray-600">
                                                        <span className="font-bold text-orange-600">Note:</span> These details are auto-extracted from your Conso file to ensure correctness and prevent validation failures.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* ORIGINAL RETURN CASE */}
                                {selectedReturnType === 'Regular' && (
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Is earlier Return Filed?
                                            </label>
                                            <select
                                                value={profileData?.section1?.isEarlierReturnFiled || 'No'}
                                                onChange={(e) => handleProfileInputChange('section1.isEarlierReturnFiled', e.target.value)}
                                                className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-900"
                                            >
                                                <option value="No">No</option>
                                                <option value="Yes">Yes</option>
                                            </select>
                                        </div>
                                        {profileData?.section1?.isEarlierReturnFiled === 'Yes' && (
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Receipt No. of Original Return <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={profileData?.section1?.receiptNoOriginal || ''}
                                                    onChange={(e) => handleProfileInputChange('section1.receiptNoOriginal', e.target.value)}
                                                    required
                                                    className="w-full px-3 py-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-blue-50 text-gray-900"
                                                    placeholder="Enter 15-digit Receipt Number"
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Navigation Tabs */}
                    <div className="flex space-x-4 mb-6 border-b border-gray-200">
                        <button
                            onClick={() => setActiveSection('tds-details')}
                            className={`pb-2 px-4 font-medium transition-colors relative ${activeSection === 'tds-details'
                                ? 'text-blue-600'
                                : 'text-gray-500 hover:text-gray-700'
                                }`}
                        >
                            TDS Details
                            {activeSection === 'tds-details' && (
                                <motion.div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" layoutId="activeTab" />
                            )}
                        </button>
                        <button
                            onClick={() => setActiveSection('challan-details')}
                            className={`pb-2 px-4 font-medium transition-colors relative ${activeSection === 'challan-details'
                                ? 'text-blue-600'
                                : 'text-gray-500 hover:text-gray-700'
                                }`}
                        >
                            Challan Details
                            {activeSection === 'challan-details' && (
                                <motion.div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" layoutId="activeTab" />
                            )}
                        </button>
                        <button
                            onClick={() => setActiveSection('profile')}
                            className={`pb-2 px-4 font-medium transition-colors ml-auto flex items-center relative ${activeSection === 'profile'
                                ? 'text-blue-600'
                                : 'text-gray-500 hover:text-gray-700'
                                }`}
                        >
                            <User className="w-4 h-4 mr-2" />
                            Profile & Settings
                            {activeSection === 'profile' && (
                                <motion.div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" layoutId="activeTab" />
                            )}
                        </button>
                    </div>

                    {/* Content Area */}
                    <div className="min-h-[500px]">
                        {activeSection === 'profile' && (
                            <TdsProfileSection
                                profileData={profileData}
                                isProfileEditing={isProfileEditing}
                                onProfileDataChange={handleProfileInputChange}
                                onPrefillClick={() => setShowPrefillPrompt(true)}
                                selectedReturnType={selectedReturnType}
                            />
                        )}

                        {activeSection === 'tds-details' && (
                            <TdsDetailsTable
                                tdsData={tdsData}
                                challanData={challanData}
                                onTdsDataChange={handleTdsDataChange}
                                selectedFinancialYear={selectedFinancialYear}
                                selectedQuarter={selectedQuarter}
                                isRevised={selectedReturnType === 'Correction'}
                                originalData={originalTdsData}
                                is27Q={true}
                                sectionOptions={selectedFinancialYear && parseInt(selectedFinancialYear.split('-')[0]) >= 2026 ? sectionOptions27Q_new : sectionOptions27Q_old}
                                remittanceOptions={remittanceOptions}
                                countryOptions={countryOptions}
                                applicableTdsOptions={applicableTdsOptions}
                                collecteeOptions={deducteeCodes27Q}
                            />
                        )}

                        {activeSection === 'challan-details' && (

                            <ChallanDetailsTable
                                challanData={challanData}
                                tdsData={tdsData}
                                onChallanDataChange={handleChallanDataChange}
                                tan={profileData?.section1?.taxDeduction}
                                financialYear={selectedFinancialYear}
                                isRevised={selectedReturnType === 'Correction'}
                                sectionOptions={selectedFinancialYear && parseInt(selectedFinancialYear.split('-')[0]) >= 2026 ? sectionOptions27Q_new : sectionOptions27Q_old}
                            />
                        )}
                    </div>
                  {activeSection === 'generated-files' && (

                    <TdsGeneratedFiles isEmbedded={true} />

                  )}

                </div>
            </main>

            {/* Sidebar */}
            <TdsSidebar
                isOpen={sidebarOpen || (!isMobile && sidebarState.isOpen)}
                onClose={handleSidebarClose}
                profileData={profileData}
                tdsData={tdsData}
                challanData={challanData}
                isProfileEditing={isProfileEditing}
                onProfileEdit={() => setIsProfileEditing(true)}
                onProfileSave={() => setIsProfileEditing(false)}
                onProfileInputChange={handleProfileInputChange}
                stateOptions={stateOptions}
                showCsiUpload={true}
                csiFile={csiFile}
                onCsiFileChange={(e) => setCsiFile(e.target.files[0])}
                isValidating={isValidating}
                onValidate={handlePrepareReturnFile}
                onCancelValidation={handleCancelValidation}
                isMobile={isMobile}
                onSidebarStateChange={handleSidebarStateChange}
                errors={[]}
                activeSection={activeSection}
                onSectionChange={handleSectionChange}
            selectionComplete={!!(selectedFinancialYear && selectedQuarter && selectedReturnType)}
            />

            {/* CSI Confirmation Modal */}
            {
                showCsiUploadPopup && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
                        <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-2xl animate-fade-in border border-gray-100">
                            <h3 className="text-xl font-bold mb-4 text-gray-800 border-b pb-2">Upload CSI File</h3>
                            <p className="text-gray-600 mb-6 leading-relaxed">
                                To proceed with validation, you need to upload the <strong>Challan Status Inquiry (CSI)</strong> file.
                                <br /><br />
                                Please ensure you have downloaded it from the Income Tax portal.
                            </p>
                            <div className="flex justify-end space-x-4">
                                <button
                                    onClick={() => setShowCsiUploadPopup(false)}
                                    className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 font-medium transition-colors duration-200"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => {
                                        setShowCsiUploadPopup(false)
                                        if (csiFileInputRef.current) {
                                            csiFileInputRef.current.value = ''
                                            csiFileInputRef.current.click()
                                        }
                                    }}
                                    className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium flex items-center transition-colors duration-200 shadow-md"
                                >
                                    <Upload className="w-4 h-4 mr-2" />
                                    Upload CSI File
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            <input
                type="file"
                ref={csiFileInputRef}
                style={{ display: 'none' }}
                accept=".csi"
                onChange={handleCsiFileChange}
            />

            {/* CSI Download Prompt Modal */}
            {
                showDownloadPrompt && (
                    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900 bg-opacity-50 backdrop-blur-sm">
                        <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md transform transition-all scale-100">
                            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                                <Upload className="w-5 h-5 mr-2 text-blue-600" />
                                Download CSI File
                            </h3>

                            <p className="text-gray-600 mb-4 text-sm">
                                Would you like to automatically download the latest CSI file from the Income Tax Portal?
                            </p>

                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Income Tax Password</label>
                                <div className="relative">
                                    <input
                                        type={showDownloadPassword ? "text" : "password"}
                                        className="w-full border border-gray-300 rounded-md p-2 pr-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                        value={downloadPassword}
                                        onChange={(e) => setDownloadPassword(e.target.value)}
                                        placeholder="Enter Password"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowDownloadPassword(!showDownloadPassword)}
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                                    >
                                        {showDownloadPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                    </button>
                                </div>
                                <p className="text-xs text-gray-500 mt-1">TAN: {profileData.section1.taxDeduction}</p>
                            </div>

                            <div className="flex space-x-3">
                                <button
                                    onClick={handleCsiDownload}
                                    disabled={isDownloadingCsi}
                                    className={`flex-1 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition flex items-center justify-center border border-transparent shadow-md ${isDownloadingCsi ? 'opacity-70 cursor-not-allowed' : ''}`}
                                >
                                    {isDownloadingCsi ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2"></div>
                                            Downloading...
                                        </>
                                    ) : (
                                        <span className="font-medium">Download & Continue</span>
                                    )}
                                </button>
                                <button
                                    onClick={handleSkipDownload}
                                    disabled={isDownloadingCsi}
                                    className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 transition"
                                >
                                    Skip (I have file)
                                </button>
                            </div>
                            <button
                                onClick={() => setShowDownloadPrompt(false)}
                                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                )
            }

            {/* Validation Lock Screen Overlay */}
            {
                isValidating && (
                    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gray-900 bg-opacity-80 backdrop-blur-sm cursor-wait">
                        <div className="bg-white p-8 rounded-2xl shadow-2xl flex flex-col items-center max-w-lg text-center transform transition-all scale-100">
                            <div className="relative mb-6">
                                <div className="absolute inset-0 bg-orange-100 rounded-full animate-ping opacity-75"></div>
                                <div className="relative bg-white rounded-full p-2">
                                    <div className="animate-spin rounded-full h-16 w-16 border-4 border-orange-200 border-t-orange-600"></div>
                                </div>
                            </div>

                            <h3 className="text-2xl font-bold text-gray-800 mb-2">Validation in Progress</h3>
                            <p className="text-gray-600 mb-6">
                                Please wait while we validate your return.
                            </p>
                            <button
                                onClick={handleCancelValidation}
                                className="px-6 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 font-medium transition-colors border border-red-200"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )
            }
            {/* Profile Pre-fill Prompt Modal */}
            {
                showPrefillPrompt && (
                    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900 bg-opacity-50 backdrop-blur-sm">
                        <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md transform transition-all scale-100">
                            <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                                <User className="w-5 h-5 mr-2 text-blue-600" />
                                Pre-fill Profile Data
                            </h3>

                            <p className="text-gray-600 mb-4 text-sm">
                                We will automatically extract your PAN, Email, Mobile and Address from the Income Tax Portal.
                            </p>

                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Income Tax Portal Password</label>
                                <div className="relative">
                                    <input
                                        type={showPrefillPassword ? "text" : "password"}
                                        className="w-full border border-gray-300 rounded-md p-2 pr-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                        value={prefillPassword}
                                        onChange={(e) => setPrefillPassword(e.target.value)}
                                        placeholder="Enter Portal Password"
                                        autoFocus
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPrefillPassword(!showPrefillPassword)}
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                                    >
                                        {showPrefillPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                    </button>
                                </div>
                                <p className="text-xs text-gray-500 mt-1">TAN: {profileData.section1.taxDeduction}</p>
                            </div>

                            <div className="flex space-x-3">
                                <button
                                    onClick={handleProfilePrefill}
                                    disabled={isExtractingProfile || !prefillPassword}
                                    className={`flex-1 bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 transition flex items-center justify-center border border-transparent shadow-md ${(isExtractingProfile || !prefillPassword) ? 'opacity-70 cursor-not-allowed' : ''}`}
                                >
                                    {isExtractingProfile ? (
                                        <>
                                            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                            Get Data...
                                        </>
                                    ) : (
                                        <>
                                            <Upload className="w-4 h-4 mr-2" />
                                            Get Data
                                        </>
                                    )}
                                </button>
                                <button
                                    onClick={() => {
                                        setShowPrefillPrompt(false);
                                        setPrefillPassword('');
                                    }}
                                    disabled={isExtractingProfile}
                                    className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 transition"
                                >
                                    Cancel
                                </button>
                            </div>
                            {!isExtractingProfile && (
                                <button
                                    onClick={() => setShowPrefillPrompt(false)}
                                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                                >
                                    <X className="w-5 h-5" />
                                </button>
                            )}
                        </div>
                    </div>
                )
            }
        </div >
    )
}

export default Tds27QCorrectionForm
